/* hgn-side-cart-kit-build.js — moved verbatim from snippets/hgn-side-cart-kit-build.liquid on 2026-09-14 (page-weight:
   inline JS → theme asset, loaded synchronously at the same position so execution order
   and DOMContentLoaded timing are unchanged). EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';
  if (window.__hgnSideCartKitBooted) return;
  window.__hgnSideCartKitBooted = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  }

  ready(function () {
    var listEl = document.querySelector('[data-hgn-side-cart-kit-list]');
    if (!listEl) return;

    /* One wording for the à-la-carte total, everywhere it appears in the
       drawer (2026-09-16). The kit PDP and the nudge card already say it
       this way; a bare strike-through on a figure nobody was ever charged
       is a reference-price claim we cannot evidence. */
    var WORTH_SUFFIX = ' if bought separately';

    var TIER_LABEL = {
      classic:     'Classic Wraps Kit',
      gels:        'Gel Wraps Kit',
      'press-ons': 'Press-On Kit'
    };
    /* ───── Curation-aware kit naming (KIT-BUILD §11h) ─────
       A kit prefilled from a curated edit is named after it on every
       surface, this panel included: "Your Halloween Edit is ready".
       kitProgress owns the rule (the name survives swaps and drops
       back to the tier name once none of the edit's designs are still
       picked); these two are thin readers with a boot-window fallback
       to exactly the previous hard-coded behaviour.

         kitLabelFor(tier)  → always a name  ("Halloween Edit" | "Classic Wraps Kit")
         editLabelFor(tier) → the EDIT name or '' — use it to decide
                              whether to name something at all, so copy
                              that is generic today stays byte-identical
                              for a hand-built kit. */
    function kitLabelFor(tier) {
      try {
        var kp = getKp();
        if (kp && typeof kp.kitLabel === 'function') {
          var v = kp.kitLabel(tier);
          if (v) return v;
        }
      } catch (e) {}
      return TIER_LABEL[tier] || 'Starter Kit';
    }
    function editLabelFor(tier) {
      try {
        var kp = getKp();
        if (kp && typeof kp.kitEditLabel === 'function') return kp.kitEditLabel(tier) || '';
      } catch (e) {}
      return '';
    }
    /* Kit-name tokens in any merchant-editable drawer string:
         {kit} / {tier}  the kit's NAME — "Halloween Edit" when it came
                         from a curated edit, "Classic Wraps Kit" otherwise.
                         Two spellings, one value, exactly as the kit-bar's
                         fillTokens: {tier} is what every existing merchant
                         string already uses and has to keep working.
         {edit}          the edit name, or the plain word "kit". For copy
                         written around the generic noun — "Your {edit}
                         price" reads "Your kit price" for a hand-built kit
                         and "Your Halloween Edit price" for a curated one. */
    function fillKitToken(tpl, tier) {
      if (!tpl) return '';
      var name = kitLabelFor(tier);
      return String(tpl)
        .split('{kit}').join(name)
        .split('{tier}').join(name)
        .split('{edit}').join(editLabelFor(tier) || 'kit');
    }
    /* Title-case singular nouns. Plural = singular + 's' (works for
       Nail Wrap, Gel Wrap, Press-On). Use `tierNoun(tier, count)` to
       resolve the right form for a given count. */
    var TIER_NOUN_SINGULAR = {
      classic:     'Nail Wrap',
      gels:        'Gel Wrap',
      'press-ons': 'Press-On'
    };
    function tierNoun(tier, count) {
      var s = TIER_NOUN_SINGULAR[tier] || 'item';
      return count === 1 ? s : s + 's';
    }
    var ACCESSORY_LABELS = {
      topCoat:      'Top Coat',
      uvLamp:       'UV Lamp',
      remover:      'Press-On Remover',
      tabs:         'Application Tabs',
      glue:         'Press-On Glue',
      giftBag:      'Gift Bag',
      magicRemover: 'Magic Remover'
    };
    /* Hardcoded fallback for the Browse-more link — used only when
       `HGN_CANONICAL_COLLECTIONS` (emitted by the announcement-bar
       header settings) hasn't loaded yet. The canonical map is the
       single source of truth across kit-bar / collection-chrome /
       focus modal redirects, so prefer it. */
    var TIER_BROWSE_FALLBACK = {
      classic:     '/collections/non-uv-nail-wraps',
      gels:        '/collections/semi-cured-gels',
      'press-ons': '/collections/press-on-nails'
    };
    function browseUrlFor(tier) {
      var canon = window.HGN_CANONICAL_COLLECTIONS || {};
      return canon[tier] || TIER_BROWSE_FALLBACK[tier] || '/collections/all';
    }
    var KIT_TIERS = ['classic', 'gels', 'press-ons'];

    /* Per-tier UI state — survives renders so a render storm can't
       collapse a slot the user just expanded or close a concertina
       mid-tap. Keys are tier strings. */
    var openSlots     = {}; // `<tier>:<slot>` → bool (option grid expanded)
    var manualOpen    = {}; // tier → 'open' / 'closed' (concertina override)

    function getKp() { return (window.HGN && window.HGN.kitProgress) ? window.HGN.kitProgress : null; }
    function tierMin(tier) {
      var m = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
        { classic: 5, gels: 3, 'press-ons': 3 };
      return m[tier] || 0;
    }
    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* ─────── Kit-pricing math + tokens ───────
       Single source of truth for the pricing-disclosure block
       (rendered below) AND for the kit-bar's {savings} token (read
       indirectly via window.HGN.computeKitMath). All values returned
       are GBP floats — the worker mints discount codes in GBP and
       HGN_KIT_BUNDLE_PRICES is GBP-priced, so the kit total is shown
       in pounds regardless of visitor currency. The shipping
       milestone is the only line that uses formatLiveCeil for live
       currency conversion (it mirrors the announcement bar).
       Per-market exception (M4): the returned math carries a `.local`
       overlay — kit price from the fixed LOCAL sticker
       (HGN_KIT_BUNDLE_PRICES_LOCAL) where one exists, and since v2
       the "Buying separately" basis from REAL local product prices
       (HGN_KIT_RETAILS_LOCAL, all markets incl. GBP) — while every
       GBP field stays canonical underneath. See localSticker() /
       localRetails() / applyLocalOverlay() below. */
    function parsePoundsValue(v) {
      if (typeof v === 'number') return v;
      if (typeof v !== 'string' || !v) return 0;
      var num = parseFloat(v.replace(/[^0-9.\-]/g, ''));
      return isNaN(num) ? 0 : num;
    }
    /* Currency-neutral money formatter. Bundle prices, uplifts, and
       savings are all GBP-anchored (HGN_KIT_BUNDLE_PRICES is GBP, the
       worker mints GBP discount codes). We pass the GBP value through
       `window.HGN.formatLive` (defined in hgn-currency.liquid) so the
       displayed amount reflects the visitor's active currency with
       friendly rounding + the correct symbol. Falls back to plain
       GBP formatting if hgn-currency hasn't loaded.
       Limitation: pick / accessory retail strings stored on items
       carry whatever currency was active at pick-time. Treat them as
       GBP-equivalent for v1 — accuracy degrades slightly for visitors
       who switch currencies mid-build, but the alternative (hiding
       retail / savings entirely for non-GBP) loses the value prop. */
    function fmtMoney(n) {
      var v = (typeof n === 'number' && isFinite(n)) ? n : 0;
      try {
        if (window.HGN && typeof window.HGN.formatLive === 'function' &&
            typeof window.HGN.activeCurrencyKey === 'function') {
          return window.HGN.formatLive(v, window.HGN.activeCurrencyKey());
        }
      } catch (e) {}
      return '\u00a3' + v.toFixed(2);
    }
    /* ─────── Per-market LOCAL sticker (M4) ───────
       `HGN_KIT_BUNDLE_PRICES_LOCAL` (announcement bar, emitted only
       for markets with per-market prices configured) carries a FIXED
       local-currency sticker per tier: `{ amount, currency }`. The
       sticker is the shopper-facing kit price — no FX float. GBP
       stays the canonical unit underneath: HGN_KIT_RETAILS, mint
       payloads and every GBP field on the math objects are untouched;
       only the kit-price display + the finalise target derive from
       the sticker. When the global is absent (GBP + unconfigured
       currencies) every code path here behaves exactly as before. */
    var LOCAL_FX_FALLBACK = { gbp: 1, usd: 1.25, eur: 1.15, cad: 1.70, aud: 1.95, nzd: 2.10, chf: 1.10 };
    function localSticker(tier) {
      var map = window.HGN_KIT_BUNDLE_PRICES_LOCAL;
      var s = map && map[tier];
      return (s && typeof s.amount === 'number' && isFinite(s.amount) &&
              s.amount > 0 && s.currency) ? s : null;
    }
    /* Live rate for the sticker's currency — same source + fallback
       table as the side cart's fxRate() so presentment→GBP inversions
       agree across the two files. */
    function localFxRate(iso) {
      var k = String(iso || '').toLowerCase();
      if (!k || k === 'gbp') return 1;
      var live = window.HGN && window.HGN.fxRates && window.HGN.fxRates[k];
      return live || LOCAL_FX_FALLBACK[k] || 1;
    }
    /* Format a LOCAL amount in its own currency (exact value, no
       friendly rounding: the sticker IS the price). The pound-string
       fallback mirrors fmtMoney's. */
    function formatLocal(amount, iso) {
      var v = (typeof amount === 'number' && isFinite(amount)) ? amount : 0;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: String(iso).toUpperCase() }).format(v);
      } catch (e) {
        return '\u00a3' + v.toFixed(2);
      }
    }
    /* ── Product-price retail basis (M4 v2) ──
       `HGN_KIT_RETAILS_LOCAL` (announcement bar, emitted for EVERY
       market incl. GBP) carries the LIVE local catalog price of a
       representative design + each accessory slot's option-A product.
       Matt's ruling: items "are only worth the product price for
       these purposes" — so when present it replaces the curated GBP
       worth table as the "Buying separately" basis (FX-converted
       worths overstated savings on marked-down catalogs like US and
       understated on marked-up ones like EU). Unusable basis (global
       absent / no `design` price / long-tail currency we can't
       rate) → worth-table fallback, i.e. the v1 behaviour. */
    var LOCAL_FX_KEYS = ['gbp', 'usd', 'eur', 'cad', 'aud', 'nzd', 'chf'];
    function localRetails(tier) {
      var map = window.HGN_KIT_RETAILS_LOCAL;
      var r = map && map[tier];
      if (!r || !r.currency) return null;
      /* Only currencies we can rate — the kit-price side needs an FX
         rate when no sticker exists, and long-tail currencies must
         keep the GBP-labelled fallback path (same rule as v1). */
      if (LOCAL_FX_KEYS.indexOf(String(r.currency).toLowerCase()) === -1) return null;
      /* No representative design price → basis unusable (the picks
         side would be zero and savings would overstate wildly). */
      if (typeof r.design !== 'number' || !isFinite(r.design) || r.design <= 0) return null;
      return r;
    }
    function localSlotRetail(lr, slot) {
      var v = lr && lr[slot];
      return (typeof v === 'number' && isFinite(v) && v > 0) ? v : 0;
    }
    /* ── Per-slot worth basis (2026-08-12) ──
       `localRetails` above is deliberately strict: it gates the whole
       SAVINGS basis, so a missing `design` price makes it return null
       and the maths falls back to the GBP worth table. Per-slot LABELS
       ("Worth CHF 24", the gift-bag chooser pips) have no such
       dependency — a slot price is usable on its own. Gating them on
       `design` is what left the accessory rows on the FX-converted
       worth table while the panel beside them quoted real local
       prices: one free bag showed three different worths in one
       drawer (CHF 11 / 17 / 19, live 2026-08-12).
       Same currency guard as localRetails — a currency we can't rate
       must keep the GBP-labelled fallback. */
    function localRetailsAny(tier) {
      var map = window.HGN_KIT_RETAILS_LOCAL;
      var r = map && map[tier];
      if (!r || !r.currency) return null;
      if (LOCAL_FX_KEYS.indexOf(String(r.currency).toLowerCase()) === -1) return null;
      return r;
    }
    /* An accessory OPTION's own catalog price in the market currency.
       `priceCents` + `priceCurrency` are emitted per option by the
       announcement bar straight from Liquid's `product.price`, so this
       is the shopper's real PDP price — no FX, no worth table. The
       older `price` string is NOT parsed as a fallback: it is a
       localised money format (`€19,00`) that a naive numeric strip
       turns into 1900. Returns null when unusable. */
    function optionLocalPrice(opt, tier) {
      if (!opt) return null;
      var cents = opt.priceCents;
      if (typeof cents !== 'number' || !isFinite(cents) || cents <= 0) return null;
      var iso = String(opt.priceCurrency || '').toUpperCase();
      if (!iso || LOCAL_FX_KEYS.indexOf(iso.toLowerCase()) === -1) return null;
      /* A PICKED accessory is replayed from kit memory, so its stamp
         can predate a currency switch. Only honour it when it still
         matches the currency this page was rendered for. */
      var lrAny = localRetailsAny(tier);
      var marketIso = lrAny ? String(lrAny.currency).toUpperCase() : activeIsoNow();
      if (marketIso && iso !== marketIso) return null;
      return { amount: cents / 100, currency: iso };
    }
    /* Slot retail for the SAVINGS basis. Identical to localSlotRetail
       except that a picked option is valued at ITS OWN price rather
       than option A's — the shopper who upgrades to the premium top
       coat is genuinely getting more, and the row label already says
       so. Currency-guarded by optionLocalPrice, so this can only ever
       return a figure in `lr.currency`. */
    function localSlotRetailFor(tier, lr, slot, acc) {
      var viaOpt = optionLocalPrice(acc, tier);
      if (viaOpt && viaOpt.currency === String(lr.currency).toUpperCase()) return viaOpt.amount;
      return localSlotRetail(lr, slot);
    }
    /* Worth of a SLOT in the shopper's own currency, with the basis
       flagged so callers can format correctly:
         local  → a real local catalog price, format verbatim
         table  → the curated GBP worth, format through formatLive
       `optionLocalPrice` wins when the shopper has actually picked an
       option (the picked variant's price beats option A's), then the
       broadcast slot price, then the GBP table. */
    function slotWorth(tier, slot, opt) {
      var viaOpt = optionLocalPrice(opt, tier);
      if (viaOpt) return { amount: viaOpt.amount, currency: viaOpt.currency, basis: 'local' };
      var lrAny = localRetailsAny(tier);
      var v = localSlotRetail(lrAny, slot);
      if (v > 0) return { amount: v, currency: String(lrAny.currency).toUpperCase(), basis: 'local' };
      var retails = (window.HGN_KIT_RETAILS && window.HGN_KIT_RETAILS[tier]) || {};
      var g = (typeof retails[slot] === 'number') ? retails[slot] : 0;
      return { amount: g, currency: '', basis: 'table' };
    }
    /* Format a slotWorth() result. '' when there's nothing to claim —
       callers must treat empty as "render no worth label" rather than
       printing a zero. */
    function worthStr(w) {
      if (!w || !(w.amount > 0)) return '';
      return w.basis === 'local' ? formatLocal(w.amount, w.currency) : fmtMoney(w.amount);
    }
    /* ── Live picks basis (2026-08-12) ──
       `picksRetail = design × count` prices every pick at ONE
       merchant-chosen representative design. That is why the drawer's
       kit saving and the basket's disagreed on CHF: the basket derives
       from the actual cart lines, the panel from the representative
       price, and the shopper's real picks were dearer. Each pick
       carries the price it was added at (`money_without_currency`, so
       a bare number) plus, since today, the currency that number is
       in. Sum the real prices when EVERY pick carries one stamped in
       the currency the shopper is in right now; a single unusable
       pick falls the whole tier back to the representative price
       rather than mixing two bases in one figure. */
    function activeIsoNow() {
      try {
        if (window.HGN && typeof window.HGN.activeCurrencyKey === 'function') {
          return String(window.HGN.activeCurrencyKey()).toUpperCase();
        }
      } catch (e) {}
      var cartCur = window.HGN && window.HGN.cartCurrency;
      if (cartCur) return String(cartCur).toUpperCase();
      return String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '').toUpperCase();
    }
    function pickLocalPrice(it, iso) {
      if (!it) return 0;
      var n = (typeof it.price === 'number') ? it.price : parseFloat(it.price);
      if (!isFinite(n) || n <= 0) return 0;
      /* No stamp = a pick from before the stamp shipped: its currency
         is unknowable, so it can't be trusted as a local figure. */
      var stamped = String(it.priceCurrency || '').toUpperCase();
      if (!stamped || stamped !== iso) return 0;
      return n;
    }
    function picksLocalRetail(picks, lr, count) {
      if (!lr) return 0;
      var iso = String(lr.currency).toUpperCase();
      /* Only trust the live sum when the shopper is still in the
         currency the broadcast was rendered for. */
      if (iso !== activeIsoNow()) return count * lr.design;
      var list = picks || [];
      var sum = 0;
      for (var i = 0; i < list.length; i++) {
        var v = pickLocalPrice(list[i], iso);
        if (v <= 0) return count * lr.design;
        sum += v;
      }
      /* Projection: designs the shopper hasn't picked yet are priced
         at the representative design, same as before. */
      return sum + Math.max(0, count - list.length) * lr.design;
    }
    /* Uplifts are GBP-configured price ADDERS, not product worths, so
       they can't come off the local price basis. But on sticker
       markets the kit price adds `uplift × rate` at the RAW rate
       (applyLocalOverlay), while fmtMoney renders them through
       formatLive's friendly rounding — so a "+£7.50" adder displayed
       as "+CHF 8" moved the kit total by CHF 8.23. Convert at the same
       raw rate the kit price uses so the chip and the total agree. */
    function fmtUplift(u, tier) {
      var v = (typeof u === 'number' && isFinite(u)) ? u : 0;
      if (v <= 0) return fmtMoney(0);
      var sticker = localSticker(tier);
      var lrAny = localRetailsAny(tier);
      var iso = sticker ? String(sticker.currency).toUpperCase()
        : (lrAny ? String(lrAny.currency).toUpperCase() : '');
      if (!iso || iso === 'GBP') return fmtMoney(v);
      return formatLocal(v * localFxRate(iso), iso);
    }
    /* Optional-slot upsell copy. With a known PDP price the row reads
       "CHF 22.00 → CHF 8.25 with kit" — the shopper can see the whole
       offer. Without one it degrades to the old surcharge-only
       phrasing rather than inventing a comparison. Plain text: the
       caller escapes it. */
    function upsellFraming(retailStr, uplift, tier) {
      var upliftStr = fmtUplift(uplift, tier);
      return retailStr
        ? retailStr + ' → ' + upliftStr + ' with kit'
        : 'Add for +' + upliftStr;
    }
    /* Attach the `.local` overlay to a math result.
       Kit-price side (v1, unchanged): sticker + uplifts converted to
       local when a sticker exists; on GBP markets (no sticker) the
       GBP bundle + uplifts ARE the local price (rate 1).
       Retail side (v2): `localBasis` = real product prices summed by
       the caller (`basis: 'product'`) when available; else the GBP
       worth table at the live rate (`basis: 'table'`, v1 behaviour).
       Displayed savings = local retail − local kit price, clamped ≥ 0.
       No sticker AND no product basis → no overlay → pure-GBP path
       byte-for-byte. */
    function applyLocalOverlay(tier, math, localBasis) {
      if (!math) return math;
      var sticker = localSticker(tier);
      var lr = localBasis && localBasis.lr;
      /* Mismatched broadcasts (sticker in one currency, retail basis
         in another) can't be subtracted — trust the sticker, drop the
         product basis for this render. */
      if (lr && sticker &&
          String(sticker.currency).toUpperCase() !== String(lr.currency).toUpperCase()) {
        lr = null;
      }
      if (!sticker && !lr) return math;
      var iso = String(sticker ? sticker.currency : lr.currency).toUpperCase();
      var rate = localFxRate(iso);
      var kitPriceLocal = sticker
        ? sticker.amount + (math.upliftTotal || 0) * rate
        : (math.bundle + (math.upliftTotal || 0)) * rate;
      var picksRetailLocal, accessoryRetailLocal, retailLocal;
      if (lr) {
        picksRetailLocal = localBasis.picksRetail || 0;
        accessoryRetailLocal = localBasis.accessoryRetail || 0;
        retailLocal = picksRetailLocal + accessoryRetailLocal;
      } else {
        picksRetailLocal = (math.picksRetail || 0) * rate;
        accessoryRetailLocal = (math.accessoryRetail || 0) * rate;
        retailLocal = (math.retail || 0) * rate;
      }
      var savingsLocal = Math.max(0, retailLocal - kitPriceLocal);
      math.local = {
        currency:        iso,
        basis:           lr ? 'product' : 'table',
        bundle:          sticker ? sticker.amount : math.bundle * rate,
        kitPrice:        kitPriceLocal,
        retail:          retailLocal,
        picksRetail:     picksRetailLocal,
        accessoryRetail: accessoryRetailLocal,
        savings:         savingsLocal,
        savingsPct:      retailLocal > 0 ? Math.round((savingsLocal / retailLocal) * 100) : 0
      };
      return math;
    }
    function computeKitMath(tier, kit) {
      var bundle = (window.HGN_KIT_BUNDLE_PRICES && window.HGN_KIT_BUNDLE_PRICES[tier]) || 0;
      var retails = (window.HGN_KIT_RETAILS && window.HGN_KIT_RETAILS[tier]) || {};
      var designRetail = (typeof retails.design === 'number') ? retails.design : 0;
      var picks = (kit && kit.items) || [];
      /* Product-price basis (v2) — when usable, walked in lockstep
         with the GBP table below so both bases count the same slots. */
      var lr = localRetails(tier);
      /* Pick retail = canonical design × pick count. Decoupled from
         each pick's stored `price` (which was whatever currency was
         active at pick-time). The kit-progress controller caps picks
         at the tier minimum, so we don't need a defensive clamp. */
      var picksRetail = picks.length * designRetail;
      /* Local side prefers the shopper's ACTUAL pick prices (see
         picksLocalRetail) so this figure reconciles with the basket's
         actual-line-price savings; representative-design × count is
         the fallback. */
      var localPicksRetail = lr ? picksLocalRetail(picks, lr, picks.length) : 0;

      var accessories = (kit && kit.accessories) || {};
      var requiredSlots = (window.HGN && window.HGN.kitProgress &&
        window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS &&
        window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
      var upliftTotal = 0;
      var accessoryRetail = 0;
      var localAccessoryRetail = 0;
      Object.keys(accessories).forEach(function (slot) {
        var acc = accessories[slot];
        if (!acc || !acc.id) return;
        upliftTotal += (typeof acc.uplift === 'number' ? acc.uplift : parsePoundsValue(acc.uplift));
        var slotRetail = (typeof retails[slot] === 'number') ? retails[slot] : 0;
        accessoryRetail += slotRetail;
        if (lr) localAccessoryRetail += localSlotRetailFor(tier, lr, slot, acc);
      });
      /* Project canonical retail for required slots the shopper hasn't
         picked yet — the kit can't be finalised without them, so they'll
         always be in the final state. Without this projection the
         displayed savings undercount until the very last pick: the gift
         bag (multi-colour choice, never auto-picked) finalises the kit
         and goes straight to cart, so the shopper would otherwise never
         see a saving figure that includes its retail. */
      requiredSlots.forEach(function (slot) {
        if (accessories[slot] && accessories[slot].id) return;
        var slotRetail = (typeof retails[slot] === 'number') ? retails[slot] : 0;
        accessoryRetail += slotRetail;
        if (lr) localAccessoryRetail += localSlotRetail(lr, slot);
      });
      var kitPrice = bundle + upliftTotal;
      var retail = picksRetail + accessoryRetail;
      var savings = Math.max(0, retail - kitPrice);
      var savingsPct = retail > 0 ? Math.round((savings / retail) * 100) : 0;
      /* `.local` overlay (M4): product-price retail basis when usable,
         sticker kit price when present; the GBP fields stay canonical
         for mint payloads + legacy consumers. */
      return applyLocalOverlay(tier, {
        bundle: bundle,
        kitPrice: kitPrice,
        upliftTotal: upliftTotal,
        retail: retail,
        savings: savings,
        savingsPct: savingsPct,
        picksRetail: picksRetail,
        accessoryRetail: accessoryRetail
      }, lr ? { lr: lr, picksRetail: localPicksRetail, accessoryRetail: localAccessoryRetail } : null);
    }
    /* Resolve free-shipping threshold in the visitor's currency from
       the announcement bar's broadcast (HGN_SIDE_CART_CONFIG.shipping)
       — same source the announcement + kit-strip use. Falls back to
       a plain GBP string if the FX helper isn't loaded. */
    function shippingThresholdLabel() {
      try {
        var cfg = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.shipping;
        if (!cfg) return '';
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
        var key = String(cur).toLowerCase();
        var gbp = cfg[key];
        if (typeof gbp !== 'number') gbp = cfg.gbp;
        if (typeof gbp !== 'number') return '';
        if (window.HGN && typeof window.HGN.formatLiveCeil === 'function') {
          return window.HGN.formatLiveCeil(gbp, key);
        }
        return '\u00a3' + gbp;
      } catch (e) {
        return '';
      }
    }
    /* Token substitution for the editor-configurable pricing copy.
       Same `{token}` syntax as the kit-bar's fillTokens but with
       pricing-specific placeholders. */
    function fillPricingTokens(tpl, math, tier) {
      if (!tpl) return '';
      var label = kitLabelFor(tier);
      /* Overlay markets (M4): kit-price-side tokens render the fixed
         local values in the market's own currency. {retail} follows
         the basis: real product prices (v2, `basis: 'product'`) render
         local; the worth-table fallback keeps fmtMoney (formatLive). */
      var loc = math.local || null;
      var bundleStr   = loc ? formatLocal(loc.bundle, loc.currency)   : fmtMoney(math.bundle);
      var kitPriceStr = loc ? formatLocal(loc.kitPrice, loc.currency) : fmtMoney(math.kitPrice);
      var savingsStr  = loc ? formatLocal(loc.savings, loc.currency)  : fmtMoney(math.savings);
      var pctVal      = loc ? loc.savingsPct : math.savingsPct;
      var retailStr   = (loc && loc.basis === 'product')
        ? formatLocal(loc.retail, loc.currency)
        : fmtMoney(math.retail);
      return String(tpl)
        .split('{bundle}').join(bundleStr)
        .split('{kitPrice}').join(kitPriceStr)
        .split('{retail}').join(retailStr)
        .split('{savings}').join(savingsStr)
        .split('{savingsPct}').join(pctVal + '%')
        .split('{tier}').join(label)
        .split('{shipping}').join(shippingThresholdLabel());
    }
    /* ── Free-shipping qualification (Matt, 2026-07-13) ──
       Does the KIT PRICE ALONE (local sticker when present, else the
       GBP bundle — INCLUDING picked uplifts) clear the market's
       free-shipping threshold? HGN_SIDE_CART_CONFIG.shipping values
       are GBP-ANCHORED numbers keyed by currency (`usd: 10` means
       £10 — a shape that's been misread twice; see SIDE-CART.md), so
       the comparison happens in GBP against the REAL threshold —
       never the ceil-rounded display value. Sticker markets invert
       the local kit price to GBP at the live rate. */
    function kitQualifiesFreeShipping(math) {
      try {
        var cfg = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.shipping;
        if (!cfg || !math) return false;
        var loc = math.local;
        var key = loc
          ? String(loc.currency).toLowerCase()
          : String((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP').toLowerCase();
        var thresholdGbp = cfg[key];
        if (typeof thresholdGbp !== 'number') thresholdGbp = cfg.gbp;
        if (typeof thresholdGbp !== 'number' || thresholdGbp <= 0) return false;
        var kitPriceGbp = loc
          ? loc.kitPrice / localFxRate(loc.currency)
          : math.kitPrice;
        return kitPriceGbp >= thresholdGbp;
      } catch (e) {
        return false;
      }
    }
    /* The qualification line itself — '' when the kit price doesn't
       qualify. Merchant copy (kit_pricing_shipping_line) wins when
       set ({shipping} renders the ceil-rounded display threshold via
       fillPricingTokens); blank falls back to the default. Shared
       with the starter-kit selector's mirrored disclosure via
       window.HGN (exposed below). */
    function kitShippingLineHtml(math, tier) {
      if (!kitQualifiesFreeShipping(math)) return '';
      var copy = window.HGN_KIT_PRICING_COPY || {};
      var tpl = copy.shippingLine;
      /* Chip treatment (Matt, 2026-07-13): every kit on every market
         now clears its free-shipping threshold, so this reads as a
         first-class benefit — the same chip atom the gift-bag row uses
         (that one now reads INCLUDED) — rather than a quiet includes
         line. FREE stays here: shipping IS free, and it is a real
         threshold benefit, not part of the a-la-carte anchor. The
         qualification guard
         above still self-retracts the claim if pricing ever changes. */
      if (tpl == null || tpl === '') {
        /* Categorical claim (Matt, 2026-07-13): "all Starter Kits" — true
           today on every market. The per-kit qualification guard above
           still gates rendering, so a future non-qualifying kit drops
           the line from ITS disclosure; if that ever happens, soften
           this copy back to a per-kit claim. */
        return '<span class="hgn-side-cart__kit-pricing-free">FREE</span> shipping on all Starter Kits';
      }
      return fillPricingTokens(tpl, math, tier);
    }
    /* Projected math — for the building-state "save up to £X" promise.
       `computeKitMath` returns ACTUAL current math, which is wrong for
       the building hint: 1 pick at canonical design retail against the
       bundle gives a negative-clamped £0 saving even though the eventual
       full kit saves £14+. This helper projects the full-kit math by:
         • Picks: canonical design retail × tier minimum (the kit will
           be filled with `min` designs, all at the standard retail).
         • Required accessories: canonical slot retail (the kit can't
           be finalised without these, so they're always present at
           full retail in the final state).
         • Optional accessories: canonical slot retail when picked
           (the shopper hasn't opted in yet otherwise). */
    function computeProjectedKitMath(tier, kit) {
      var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
        { classic: 5, gels: 3, 'press-ons': 3 };
      var min = minimums[tier] || 0;
      var bundle = (window.HGN_KIT_BUNDLE_PRICES && window.HGN_KIT_BUNDLE_PRICES[tier]) || 0;
      var retails = (window.HGN_KIT_RETAILS && window.HGN_KIT_RETAILS[tier]) || {};
      var designRetail = (typeof retails.design === 'number') ? retails.design : 0;
      /* Product-price basis (v2) — projected with the same semantics
         as the GBP walk below (min picks + all required slots +
         picked optionals). */
      var lr = localRetails(tier);
      var projectedPicksRetail = min * designRetail;
      /* Picks already made price at their REAL local price; the ones
         still to come project at the representative design. */
      var localPicksRetail = lr ? picksLocalRetail((kit && kit.items) || [], lr, min) : 0;

      var requiredSlots = (window.HGN && window.HGN.kitProgress &&
        window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS &&
        window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
      var pickedAcc = (kit && kit.accessories) || {};
      var projectedAccRetail = 0;
      var localAccRetail = 0;
      var upliftTotal = 0;

      requiredSlots.forEach(function (slot) {
        var slotRetail = (typeof retails[slot] === 'number') ? retails[slot] : 0;
        projectedAccRetail += slotRetail;
        var picked = pickedAcc[slot];
        if (lr) localAccRetail += localSlotRetailFor(tier, lr, slot, picked);
        if (picked && picked.id) {
          upliftTotal += (typeof picked.uplift === 'number' ? picked.uplift : parsePoundsValue(picked.uplift));
        }
      });
      Object.keys(pickedAcc).forEach(function (slot) {
        if (requiredSlots.indexOf(slot) !== -1) return; // already counted
        var acc = pickedAcc[slot];
        if (!acc || !acc.id) return;
        var slotRetail = (typeof retails[slot] === 'number') ? retails[slot] : 0;
        projectedAccRetail += slotRetail;
        if (lr) localAccRetail += localSlotRetailFor(tier, lr, slot, acc);
        upliftTotal += (typeof acc.uplift === 'number' ? acc.uplift : parsePoundsValue(acc.uplift));
      });

      var kitPrice = bundle + upliftTotal;
      var projectedRetail = projectedPicksRetail + projectedAccRetail;
      var savings = Math.max(0, projectedRetail - kitPrice);
      var savingsPct = projectedRetail > 0 ? Math.round((savings / projectedRetail) * 100) : 0;
      /* Same `.local` overlay as computeKitMath (M4) so the projected
         "save up to X" hint quotes the market's basis + sticker. */
      return applyLocalOverlay(tier, {
        bundle: bundle,
        kitPrice: kitPrice,
        upliftTotal: upliftTotal,
        retail: projectedRetail,
        savings: savings,
        savingsPct: savingsPct,
        picksRetail: projectedPicksRetail,
        accessoryRetail: projectedAccRetail
      }, lr ? { lr: lr, picksRetail: localPicksRetail, accessoryRetail: localAccRetail } : null);
    }

    /* Expose for the kit-bar's `{savings}` token wiring; the
       shipping-line builder feeds the selector's mirrored disclosure
       so both surfaces qualify + word the line identically. */
    window.HGN = window.HGN || {};
    window.HGN.computeKitMath = computeKitMath;
    window.HGN.computeProjectedKitMath = computeProjectedKitMath;
    window.HGN.kitShippingLineHtml = kitShippingLineHtml;

    /* Build the pricing block. Surfaces once a shopper has 1+ picks.
       In building state shows projected math (current picks vs current
       bundle); in ready state shows actual locked math (with active
       accessory uplifts already applied). */
    /* ─────── Required-slot fill state (single source) ───────
       WHICH required accessory slots are still unpicked for this tier
       (missingRequired), and how many (requiredUnfilled — the shape
       every existing caller uses). This is THE all-set test — the
       blocking-slot focus jump, the acc-block eyebrow, the
       finalise CTA, the all-set announce and the side cart's foot
       button all read it, so the definition can never drift between
       surfaces. Mirrors the fallback list the acc block has always
       used when the announcement bar hasn't broadcast slot config. */
    function missingRequired(tier, kit) {
      var kp = getKp();
      var requiredSlots = (kp && kp.REQUIRED_ACCESSORY_SLOTS && kp.REQUIRED_ACCESSORY_SLOTS[tier]) ||
        (tier === 'press-ons' ? ['remover', 'giftBag'] : (tier === 'gels' ? ['uvLamp', 'giftBag'] : ['topCoat', 'giftBag']));
      var picksAcc = (kit && kit.accessories) || {};
      return requiredSlots.filter(function (s) { return !picksAcc[s]; });
    }
    function requiredUnfilled(tier, kit) {
      return missingRequired(tier, kit).length;
    }

    /* ─────── One "what's left" model (audit A2, 2026-08-12) ───────
       At 5/5 with the gift bag unpicked the drawer said three things
       at once: head "Ready · pick accessories", progress line "Kit
       ready!", accessory eyebrow "Pick 1 more to finish your kit" —
       ready and not-ready in the same viewport. Every one of those
       surfaces now renders from stepsCopy(), so they cannot disagree,
       and the copy NAMES the blocking slot instead of counting
       anonymous "more"s: "1 step left — pick your gift bag".
       `noun` is the shopper-facing name for the step, which is not
       always the merchandising label (giftBag's row reads "Gift Bag",
       but the thing they're being asked for is their gift bag). */
    var STEP_NOUN = {
      giftBag: 'gift bag',
      topCoat: 'top coat',
      uvLamp:  'UV lamp',
      remover: 'press-on remover'
    };
    function stepsCopy(tier, kit) {
      var missing = missingRequired(tier, kit);
      var n = missing.length;
      var nouns = missing.map(function (s) {
        return STEP_NOUN[s] || String(ACCESSORY_LABELS[s] || s).toLowerCase();
      });
      return {
        count:   n,
        slot:    missing[0] || null,
        eyebrow: n === 0
          ? (editLabelFor(tier) ? editLabelFor(tier) + ' complete' : 'Kit complete')
          : (n + ' step' + (n === 1 ? '' : 's') + ' left'),
        action:  n === 0 ? '' : ('pick your ' + nouns.join(' + '))
      };
    }

    /* Does the Shopify cart have real lines? Decides between the
       kit-only presentation (foot one-tap owns checkout; copy says
       "ready to check out") and the mixed-basket one (in-list CTA
       folds the kit in; copy says "ready to add to basket").
       Deploy-skew fallback: an older side-cart file without
       itemCount() reports MIXED, so the in-list CTA still renders —
       a duplicate button beats a kit with no commit action. */
    function cartHasLines() {
      try {
        if (window.HGN && window.HGN.sideCart &&
            typeof window.HGN.sideCart.itemCount === 'function') {
          return window.HGN.sideCart.itemCount() > 0;
        }
      } catch (e) {}
      return true;
    }

    function buildPricingBlockHtml(tier, kit, math, ready) {
      if (!math || !math.bundle) return '';
      var picks = (kit && kit.items) ? kit.items.length : 0;
      if (picks < 1) return '';
      var copy = (window.HGN_KIT_PRICING_COPY || {});
      function copyOr(key, fallback) {
        var v = copy[key];
        return (v == null || v === '') ? fallback : v;
      }
      /* {edit} renders the curated edit's name or the plain word "kit",
         so this title is byte-identical to the pre-2026-09-15 copy for a
         hand-built kit and names the edit for a curated one. The Liquid
         `default:` was removed from this setting for the same reason
         kit_bar_*_eyebrow has none — a Liquid default always beats
         copyOr(), and the tokenizer cannot hold a braced default. */
      var title       = fillKitToken(copyOr('title', 'Your {edit} price'), tier);
      var labelKit    = copyOr('labelKitPrice', 'Kit price');
      /* The announcement's `labelRetail` ("Buying separately") no longer
         renders (2026-09-16). The sum-of-parts figure now carries its own
         qualifier — "£63.93 if bought separately", the exact wording the
         kit PDP and the drawer nudge card use — so printing a label too
         would say the same thing twice. See the worth row below. */
      /* Scoped on purpose (2026-08-12): the drawer foot carries a
         BASKET-wide "You save" (kit + free gift + any folded offer,
         from actual cart lines) and this one is KIT-only. Two figures
         under identical labels on one screen read as a contradiction —
         the audit flagged exactly that. Merchant copy still wins. */
      var labelSave   = copyOr('labelSave', 'You save on this kit');
      var includesHd  = copyOr('includesHead', 'Includes');
      var buildingTpl = copyOr('buildingHint', 'Once full: pay <strong>{kitPrice}</strong> · save up to <strong>{savings}</strong>');

      /* Product-price basis (M4 v2): when the overlay carries real
         local catalog prices (`basis: 'product'`), every "worth" pip
         and the retail row render from them in the market's own
         currency. The GBP worth-table path (no overlay, or the
         transitional sticker-only `basis: 'table'`) keeps fmtMoney
         exactly as before. */
      var loc = math.local || null;
      var productBasis = !!(loc && loc.basis === 'product');
      function fmtWorthVal(v) {
        return productBasis ? formatLocal(v, loc.currency) : fmtMoney(v);
      }

      /* Includes list — concise lines that explain what the kit
         actually contains at this price. We include the picks count,
         each picked accessory (by label), and the shipping milestone
         when its threshold is met by the kit price. */
      var minimum = tierMin(tier);
      var label = kitLabelFor(tier);
      var includes = [];
      /* Picks line — show the count + retail value of those picks
         when we have it, so the shopper sees the value-prop spelled
         out: "5 Nail Wraps · worth £49.95 separately". */
      var picksLineHtml = '<strong>' + minimum + '</strong> ' + tierNoun(tier, minimum);
      var picksWorth = productBasis ? loc.picksRetail : math.picksRetail;
      if (picksWorth > 0) {
        picksLineHtml += ' <span class="hgn-side-cart__kit-pricing-worth">worth ' + escapeHtml(fmtWorthVal(picksWorth)) + '</span>';
      }
      includes.push(picksLineHtml);
      /* Accessories list — every required slot renders whether picked
         or not (so the line-by-line matches the math, which projects
         required-slot retail even before the shopper has picked).
         Optional slots only render once picked. Picked rows show the
         variant name + retail value; unpicked required rows show
         "(pick yours)" with the same FREE / worth-£X tone pill so
         the value-prop reads consistently. */
      var accessories = (kit && kit.accessories) || {};
      var requiredSlotsForPricing = (window.HGN && window.HGN.kitProgress &&
          window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS &&
          window.HGN.kitProgress.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
      var pricingAccData = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
      function pricingRowFor(slot, acc) {
        var lbl = ACCESSORY_LABELS[slot] || slot;
        /* Worth value: the picked option's real local price, else the
           slot's local price, else the GBP worth table (slotWorth
           walks exactly that ladder — and it is the SAME ladder the
           accessory rows below use, so a slot can no longer show one
           worth here and another there). */
        var retailStrFor = worthStr(slotWorth(tier, slot, acc));
        var isReq = requiredSlotsForPricing.indexOf(slot) !== -1;
        var picked = !!(acc && acc.id);
        var upl = picked
          ? (typeof acc.uplift === 'number' ? acc.uplift : parsePoundsValue(acc.uplift))
          : 0;
        var name = escapeHtml(lbl) + (picked && acc.title ? ': ' + escapeHtml(acc.title) : '');
        if (!picked) name += ' <span class="hgn-side-cart__kit-pricing-worth">(pick yours)</span>';
        var hint;
        if (upl > 0) {
          /* Uplift chips are price ADDERS, not product worths — but on
             sticker markets they must be converted at the SAME raw
             rate the kit price uses, hence fmtUplift not fmtMoney.
             Framed as "was X → +Y with kit" when we know the option's
             real price, so the upsell reads as the discount it is
             rather than a bare surcharge. */
          var upliftStr = '+' + fmtUplift(upl, tier);
          hint = retailStrFor
            ? ' <span class="hgn-side-cart__kit-pricing-worth"><s>' + escapeHtml(retailStrFor) + '</s></span>' +
              ' <span class="hgn-side-cart__kit-pricing-uplift">' + escapeHtml(upliftStr) + '</span>'
            : ' <span class="hgn-side-cart__kit-pricing-uplift">' + escapeHtml(upliftStr) + '</span>';
        } else if (slot === 'giftBag') {
          /* The merchant-curated gift bag — the only slot that gets an
             INCLUDED chip. Other required slots show "worth £X" below.
             Matt's decision, 2026-09-16 (audit P1-5 option i): the bag
             stays inside the a-la-carte anchor that produces the saving,
             so it cannot also be called "free" — it is included. The
             class name keeps its `-free` spelling: it is the chip style,
             and renaming it would orphan the rule in hgn-side-cart.css. */
          hint = ' <span class="hgn-side-cart__kit-pricing-free">Included</span>';
          if (retailStrFor) {
            hint += ' <span class="hgn-side-cart__kit-pricing-worth">worth ' + escapeHtml(retailStrFor) + '</span>';
          }
        } else if (isReq && retailStrFor) {
          hint = ' <span class="hgn-side-cart__kit-pricing-worth">worth ' + escapeHtml(retailStrFor) + '</span>';
        } else {
          hint = '';
        }
        return name + hint;
      }
      /* Required slots — render in canonical order so the line-by-line
         is stable across renders (Object.keys ordering is engine-defined
         and would shuffle as the shopper picks). Skip slots the merchant
         hasn't configured (no options) — they're not actually shipping
         in the kit, so projecting them in the includes list would lie. */
      requiredSlotsForPricing.forEach(function (slot) {
        var options = pricingAccData[slot] || [];
        if (options.length === 0) return;
        includes.push(pricingRowFor(slot, accessories[slot]));
      });
      /* Optional slots — only when the shopper has actively opted in. */
      Object.keys(accessories).forEach(function (slot) {
        if (requiredSlotsForPricing.indexOf(slot) !== -1) return;
        var acc = accessories[slot];
        if (!acc || !acc.id) return;
        includes.push(pricingRowFor(slot, acc));
      });
      /* Free-shipping QUALIFICATION line — reinstated 2026-07-13 by
         Matt's call, and a DIFFERENT thing from the order-total
         milestone removed earlier (that one tracked cart progress
         toward the threshold and still lives in the side cart's top
         strip). This line states a fact about the kit itself: the
         kit price alone (sticker/bundle + picked uplifts) already
         clears the market's free-shipping threshold. Renders in both
         building + ready states via the shared includes list. */
      var shippingLine = kitShippingLineHtml(math, tier);
      if (shippingLine) includes.push(shippingLine);

      var includesHtml = includes.length
        ? '<ul class="hgn-side-cart__kit-pricing-includes">' +
            includes.map(function (line) { return '<li>' + line + '</li>'; }).join('') +
          '</ul>'
        : '';

      /* Building-state hint — shown when the kit isn't yet at minimum.
         Uses PROJECTED math for the {savings} / {bundle} / {kitPrice}
         tokens so the "save up to £X" promise reflects the eventual
         full-kit value, not the user's partial picks (which would
         clamp savings to £0 when retail < bundle price). */
      if (!ready) {
        if (!buildingTpl) return '';
        var projection = computeProjectedKitMath(tier, kit);
        return '<div class="hgn-side-cart__kit-pricing hgn-side-cart__kit-pricing--building">' +
            '<p class="hgn-side-cart__kit-pricing-hint">' +
              fillPricingTokens(buildingTpl, projection, tier) +
            '</p>' +
            includesHtml +
          '</div>';
      }

      /* Ready state — full breakdown table + includes. Overlay
         markets (M4): kit-price + save rows use the fixed local
         values; "Buying separately" follows the basis — real product
         prices in local currency (v2) or the GBP worth table via
         fmtMoney (fallback). */
      var kitPriceStr = loc ? formatLocal(loc.kitPrice, loc.currency) : fmtMoney(math.kitPrice);
      var savingsStr  = loc ? formatLocal(loc.savings, loc.currency)  : fmtMoney(math.savings);
      var pctVal      = loc ? loc.savingsPct : math.savingsPct;
      var showSave    = loc ? loc.savings > 0 : math.retail > math.kitPrice;
      var retailStr   = productBasis ? formatLocal(loc.retail, loc.currency) : fmtMoney(math.retail);
      var savePct = pctVal > 0 ? ' <span class="hgn-side-cart__kit-pricing-pct">(' + pctVal + '%)</span>' : '';
      return '<div class="hgn-side-cart__kit-pricing">' +
          '<p class="hgn-side-cart__kit-pricing-title">' + escapeHtml(title) + '</p>' +
          '<div class="hgn-side-cart__kit-pricing-rows">' +
            '<div class="hgn-side-cart__kit-pricing-row">' +
              '<span>' + escapeHtml(labelKit) + '</span>' +
              '<span class="hgn-side-cart__kit-pricing-row-value">' + kitPriceStr + '</span>' +
            '</div>' +
            (showSave
              /* Worth row (2026-09-16): the sum of the parts is NOT a
                 was-price — nobody was ever charged £63.93 — so it is
                 never struck through. One qualified line, the same
                 wording as the kit PDP and the nudge card. The
                 `--strike` modifier stays: it is the muted row style in
                 hgn-side-cart.css and renaming it would orphan the rule
                 (and its 12px narrow-screen partner). Real was-prices
                 elsewhere — cart line prices, the pair offer, the
                 uplift "was £X → +£Y" chip above — are untouched. */
              ? '<div class="hgn-side-cart__kit-pricing-row hgn-side-cart__kit-pricing-row--strike hgn-side-cart__kit-pricing-row--worth" data-hgn-kit-worth>' +
                  '<span class="hgn-side-cart__kit-pricing-worthline">' +
                    '<span class="hgn-side-cart__kit-pricing-row-value">' + retailStr + '</span>' + WORTH_SUFFIX +
                  '</span>' +
                '</div>' +
                '<div class="hgn-side-cart__kit-pricing-row hgn-side-cart__kit-pricing-row--save">' +
                  '<span>' + escapeHtml(labelSave) + '</span>' +
                  '<span class="hgn-side-cart__kit-pricing-row-value">' + savingsStr + savePct + '</span>' +
                '</div>'
              : ''
            ) +
          '</div>' +
          (includesHtml ? '<p class="hgn-side-cart__kit-pricing-includes-head">' + escapeHtml(includesHd) + '</p>' + includesHtml : '') +
        '</div>';
    }

    /* ─────── Section markup builder (one per tier) ───────
       Returns the full HTML for a single tier's section. The
       controller composes the whole list from these strings. */
    function buildSectionHtml(tier, kit) {
      var picks = (kit && kit.items) ? kit.items.length : 0;
      var minimum = tierMin(tier);
      var ready = picks >= minimum;
      var label = kitLabelFor(tier);
      var openOverride = manualOpen[tier];
      var desiredOpen = openOverride === 'open' || (openOverride !== 'closed' && ready);
      var pct = minimum > 0 ? Math.min(100, Math.round((picks / minimum) * 100)) : 0;
      var classes = ['hgn-side-cart__kit'];
      if (ready) classes.push('is-ready');
      /* Math is computed up front (not just for the pricing block)
         because the finalise CTA quotes the kit price + saving in its
         own label — the review-then-add button has to earn the tap. */
      var math = computeKitMath(tier, kit);

      var picksHtml = picks === 0
        ? '<p style="font-size:13px;color:var(--hgn-text-muted);margin:0;">No designs picked yet.</p>'
        : kit.items.map(function (it) {
            var thumb = it.image ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">' : '';
            return '<div class="hgn-side-cart__kit-pick" data-id="' + escapeHtml(it.id) + '">' +
              '<div class="hgn-side-cart__kit-pick-thumb">' + thumb + '</div>' +
              '<p class="hgn-side-cart__kit-pick-title">' + escapeHtml(it.title || '') + '</p>' +
              /* Quick view (2026-09-15): a mini-PDP for THIS pick, so a shopper
                 can check what they are getting without leaving the drawer.
                 Markup only — hgn-quick-view.liquid owns the delegated
                 capture-phase listener, so this adds no subscription and rides
                 the same buildSectionHtml string rebuild every other row does
                 (idempotent by construction). A sibling of the remove button,
                 never inside it. */
              (it.handle
                ? '<button type="button" class="hgn-qv-trigger" data-hgn-qv-handle="' + escapeHtml(it.handle) + '" data-hgn-qv-context="drawer" aria-label="Quick view: ' + escapeHtml(it.title || it.handle) + '">' +
                    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
                      '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>' +
                      '<path d="M12 11v5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
                      '<circle cx="12" cy="8" r="1" fill="currentColor"/>' +
                    '</svg>' +
                  '</button>'
                : '') +
              '<button type="button" class="hgn-side-cart__kit-pick-remove" data-hgn-kit-pick-remove data-id="' + escapeHtml(it.id) + '" aria-label="Remove from kit">' +
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                  '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
                '</svg>' +
              '</button>' +
            '</div>';
          }).join('');

      /* All-set + basket-context aware status line (Matt, 2026-08-08
         rev 3): a completed kit must SAY it's complete and point at
         its actual commit action — the first cut kept "choose your
         accessories" copy under a finished kit next to a £0.00 foot,
         which read as nothing-has-happened. */
      var stepsForCopy = ready ? stepsCopy(tier, kit) : null;
      var unfilledForCopy = stepsForCopy ? stepsForCopy.count : -1;
      var mixedBasket = cartHasLines();
      var progressLine;
      if (ready && unfilledForCopy === 0) {
        /* Named when the kit came from a curated edit: "Your Halloween
           Edit is ready". Generic copy is untouched otherwise. */
        var setEdit = editLabelFor(tier);
        var setName = setEdit ? escapeHtml(setEdit) : 'kit';
        progressLine = mixedBasket
          ? '<strong>All set!</strong> Add your ' + setName + ' ' + ((window.HGN_COPY || {}).kit_add_below || 'to your basket below.')
          : '<strong>All set!</strong> Your ' + setName + ' is ready — checkout below when you are.';
      } else if (ready) {
        /* A2: was "Kit ready! Choose your accessories below to finish
           it." — a ready-state headline over an unfinished kit. */
        progressLine = '<strong>' + escapeHtml(stepsForCopy.eyebrow) + '</strong> — ' +
          escapeHtml(stepsForCopy.action) + ' below to finish your kit.';
      } else {
        progressLine = 'Pick <strong>' + Math.max(0, minimum - picks) + ' more</strong> ' + tierNoun(tier, minimum - picks) + ' to fill your kit.';
      }

      /* Accessories step — only when ready. Auto-pick of singletons
         runs in a pre-render pass (see render() below) so the
         setAccessory event doesn't recurse into render mid-build. */
      var accHtml = '';
      if (ready) {
        var kp = getKp();
        var slots = (kp && kp.ACCESSORY_SLOTS && kp.ACCESSORY_SLOTS[tier]) || [];
        var requiredSlots = (kp && kp.REQUIRED_ACCESSORY_SLOTS && kp.REQUIRED_ACCESSORY_SLOTS[tier]) ||
          (tier === 'press-ons' ? ['remover', 'giftBag'] : (tier === 'gels' ? ['uvLamp', 'giftBag'] : ['topCoat', 'giftBag']));
        var accData = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
        var picksAcc = (kit.accessories) || {};
        var steps = stepsCopy(tier, kit);
        var unfilled = steps.count;
        /* A2: same model as the head eyebrow + progress line above —
           "1 step left — pick your gift bag", never "Pick 1 more"
           under a headline that already claimed the kit was ready. */
        var accEyebrow = unfilled === 0
          ? (mixedBasket ? ((window.HGN_COPY || {}).kit_ready_add || 'All set \u2014 ready to add to basket') : 'All set \u2014 ready to check out')
          : (steps.eyebrow + ' \u2014 ' + steps.action);
        accHtml = '<div class="hgn-side-cart__kit-acc">' +
          '<p class="hgn-side-cart__kit-acc-eyebrow">' + escapeHtml(accEyebrow) + '</p>' +
          '<div class="hgn-side-cart__kit-acc-list">' +
            slots.map(function (slot) {
              var pick = picksAcc[slot] || null;
              var required = requiredSlots.indexOf(slot) !== -1;
              var lbl = ACCESSORY_LABELS[slot] || slot;
              var options = accData[slot] || [];
              var singleton = options.length === 1;
              var noOptions = options.length === 0;
              var requiredSingleton = singleton && required;
              /* Skip any slot with no configured options. An empty
                 options array means the merchant hasn't set the slot
                 up in announcement-bar settings (or has gated it off
                 — e.g. Magic Remover with a blank/zero uplift). The
                 side cart treats unconfigured = invisible regardless
                 of required/optional status. Misconfigured required
                 slots fail silently here; the theme-editor preview is
                 the canonical place to catch that. */
              if (noOptions) return '';
              /* Display image — picked option's image when chosen,
                 otherwise the first option's image as a representative
                 preview so the row never looks blank. Falls back to a
                 small placeholder glyph when no image data exists. */
              var displayImage = '';
              if (pick && pick.image) displayImage = pick.image;
              else if (options[0] && options[0].image) displayImage = options[0].image;
              var thumbHtml = displayImage
                ? '<img src="' + escapeHtml(displayImage) + '" alt="" loading="lazy">'
                : '<span class="hgn-side-cart__kit-acc-row-thumb-empty" aria-hidden="true">+</span>';
              /* Per-slot value disclosure — required slots advertise
                 the retail value the shopper gets for free; optional
                 slots show the uplift (or "free" if zero).
                 The worth comes from slotWorth(): the picked (or
                 representative) option's REAL price in the shopper's
                 own currency, falling back to the GBP worth table only
                 when no local price is broadcast. Before 2026-08-12
                 this row read HGN_KIT_RETAILS — a curated GBP table —
                 and pushed it through formatLive's friendly rounding,
                 so a CHF 24.00 top coat advertised as "Worth CHF 15"
                 and a $16.00 gift bag as "$19" (an OVERSTATED value
                 claim on marked-down catalogs). It is now the same
                 ladder the pricing block's includes list walks, so the
                 two can no longer disagree inside one drawer. */
              var rowWorth = slotWorth(tier, slot, pick || options[0]);
              var primaryRetailStr = worthStr(rowWorth);
              var pickUplift = pick && typeof pick.uplift === 'number'
                ? pick.uplift
                : (options[0] && typeof options[0].uplift === 'number' ? options[0].uplift : 0);
              /* The INCLUDED chip is reserved for the merchant-curated
                 gift-bag slot only — that's the one positioned in the
                 announcement bar as the kit's gift bag. Top coat / UV
                 lamp / press-on remover etc. are integral kit
                 components and keep their existing "Worth £X"
                 treatment (the kit price already factors them in).
                 Neither says "free": the bag is counted inside the
                 a-la-carte anchor (audit P1-5 option i, 2026-09-16). */
              var isGiftBag = slot === 'giftBag';
              var meta;
              if (noOptions) {
                meta = '<span class="hgn-side-cart__kit-acc-row-meta--muted">Currently unavailable</span>';
              } else if (pick) {
                var pickedTone = '';
                if (isGiftBag && pickUplift <= 0) {
                  pickedTone = '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--free">Included</span>';
                  if (primaryRetailStr) {
                    pickedTone += '<span class="hgn-side-cart__kit-acc-row-worth">worth ' + escapeHtml(primaryRetailStr) + '</span>';
                  }
                } else if (required) {
                  if (primaryRetailStr) {
                    pickedTone = '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--included">Worth ' + escapeHtml(primaryRetailStr) + '</span>';
                  }
                } else if (pickUplift > 0) {
                  pickedTone = '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--addon">' +
                    escapeHtml(upsellFraming(primaryRetailStr, pickUplift, tier)) + '</span>';
                }
                meta = '<span class="hgn-side-cart__kit-acc-row-pick">' + escapeHtml(pick.title || '') + '</span>' + pickedTone;
              } else if (isGiftBag) {
                /* Unpicked gift bag: INCLUDED chip + "pick yours" hint. */
                var giftHint = primaryRetailStr
                  ? 'pick yours \u00b7 worth ' + escapeHtml(primaryRetailStr)
                  : 'pick yours';
                meta = '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--free">Included</span>' +
                       '<span class="hgn-side-cart__kit-acc-row-worth">' + giftHint + '</span>';
              } else if (required) {
                /* Unpicked required (top coat / UV lamp / remover):
                   lead with the value-prop. The kit price already
                   includes this slot, so the tone is informational. */
                var retailHint = primaryRetailStr
                  ? 'Worth ' + escapeHtml(primaryRetailStr) + ' \u2014 pick yours'
                  : 'Pick yours';
                meta = '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--included">' + retailHint + '</span>';
              } else {
                /* Optional, unpicked (Magic Remover / tabs / glue):
                   the upsell's own PDP price \u2192 its kit price, so the
                   shopper can see the saving instead of only the
                   surcharge ("Add for +CHF 8" beside a CHF 22.00 PDP
                   read as an unexplained number, live 2026-08-12). */
                meta = pickUplift > 0
                  ? '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--addon">' +
                      escapeHtml(upsellFraming(primaryRetailStr, pickUplift, tier)) + '</span>'
                  : '<span class="hgn-side-cart__kit-acc-row-tone hgn-side-cart__kit-acc-row-tone--addon">Optional add-on</span>';
              }

              var rowClasses = ['hgn-side-cart__kit-acc-row'];
              if (required) rowClasses.push('is-required');
              if (pick) rowClasses.push('is-picked');
              /* `is-singleton` flag is reserved for REQUIRED single-option
                 slots (e.g. classic top coat — the kit always includes
                 it; no choice to make). Optional singletons (Magic
                 Remover) act like normal pickable rows so the shopper
                 can opt in/out, even though there's only one option. */
              if (requiredSingleton) rowClasses.push('is-singleton');
              if (noOptions) rowClasses.push('is-empty');

              var actionLabel;
              if (noOptions) actionLabel = 'N/A';
              else if (requiredSingleton) actionLabel = 'Included';
              else if (singleton) actionLabel = pick ? 'Remove' : 'Add';
              else actionLabel = pick ? 'Change' : 'Pick';
              var slotKey = tier + ':' + slot;
              var isOpen = !!openSlots[slotKey];
              /* Disabled state — only when there's nothing to pick OR
                 the slot is a required singleton (auto-picked, no
                 choice). Optional singletons stay enabled so they
                 toggle. Multi-option slots stay enabled. */
              var actionDisabled = noOptions || requiredSingleton;
              var optsHtml = '';
              if (!noOptions && !singleton) {
                optsHtml = '<div class="hgn-side-cart__kit-acc-options"' + (isOpen ? '' : ' hidden') + '>' +
                  options.map(function (opt) {
                    var picked = pick && String(pick.id) === String(opt.id);
                    var thumb = opt.image ? '<img src="' + escapeHtml(opt.image) + '" alt="" loading="lazy">' : '';
                    /* Per-option pip — uplift if there's one, otherwise
                       the option's retail "worth" so the shopper sees
                       the value the bundle factors in.
                       The worth is THIS option's own local catalog
                       price (slotWorth → optionLocalPrice). It used to
                       be `parsePoundsValue(opt.price)` — which strips
                       the symbol off an already-LOCAL money string and
                       then formatLive-converts the result AS IF it were
                       GBP, so a CHF 17.00 gift bag showed "Worth CHF 19"
                       on the tile while its own row said CHF 11 and the
                       includes panel said CHF 17 (live 2026-08-12).
                       It also mis-parsed comma-decimal formats (€19,00
                       → 1900). */
                    var optWorthStr = worthStr(slotWorth(tier, slot, opt));
                    var uplift = '';
                    if (opt.uplift && opt.uplift > 0) {
                      uplift = '<span class="hgn-side-cart__kit-acc-option-uplift">+' + escapeHtml(fmtUplift(opt.uplift, tier)) + '</span>';
                    } else if (required && optWorthStr) {
                      uplift = '<span class="hgn-side-cart__kit-acc-option-uplift hgn-side-cart__kit-acc-option-uplift--worth">Worth ' + escapeHtml(optWorthStr) + '</span>';
                    }
                    return '<button type="button" class="hgn-side-cart__kit-acc-option' + (picked ? ' is-picked' : '') +
                      '" data-hgn-kit-acc-option data-slot="' + escapeHtml(slot) + '" data-id="' + escapeHtml(opt.id) + '">' +
                      '<span class="hgn-side-cart__kit-acc-option-thumb">' + thumb + '</span>' +
                      '<p class="hgn-side-cart__kit-acc-option-title">' + escapeHtml(opt.title || '') + '</p>' +
                      uplift +
                    '</button>';
                  }).join('') +
                '</div>';
              }
              /* `data-slot` on the row itself (A2) — the FINISH-MY-KIT
                 focus jump needs to address the blocking row, not just
                 its action button. */
              return '<div class="' + rowClasses.join(' ') + '" data-slot="' + escapeHtml(slot) + '">' +
                '<div class="hgn-side-cart__kit-acc-row-thumb">' + thumbHtml + '</div>' +
                '<div class="hgn-side-cart__kit-acc-row-label">' +
                  '<span class="hgn-side-cart__kit-acc-row-name">' + escapeHtml(lbl) + '</span>' +
                  '<span class="hgn-side-cart__kit-acc-row-meta">' + meta + '</span>' +
                '</div>' +
                '<button type="button" class="hgn-side-cart__kit-acc-row-action" data-hgn-kit-acc-toggle data-slot="' + escapeHtml(slot) + '"' + (actionDisabled ? ' disabled' : '') + '>' +
                  escapeHtml(actionLabel) +
                '</button>' +
                optsHtml +
              '</div>';
            }).join('') +
          '</div>' +
          /* Review-then-add (Matt, 2026-08-05): the explicit basket CTA.
             Finalise ONLY runs from this tap now — the automatic trigger
             on the last accessory pick is retired (see the listener note
             below). Restyled 2026-08-08 (Matt: "far from obvious"): its
             own terracotta class + the kit price/saving in the label.
             MIXED BASKETS ONLY (Matt's slicker rule, same day): on a
             kit-only cart the foot's "Checkout with my kit" one-tap is
             the single action — rendering this too made two buttons
             that both add the kit. With other lines in the cart this
             button = "fold the kit in", the foot = plain Checkout.
             Fallback: if the side-cart facade predates itemCount()
             (deploy skew), render the CTA — a duplicate button beats
             a kit with no commit action at all. */
          (unfilled === 0 && finalising && finalising[tier]
            ? '<button type="button" class="hgn-side-cart__kit-finalise" data-hgn-kit-finalise disabled><span class="hgn-side-cart__kit-finalise-label">Adding your kit\u2026</span></button>'
            : '') +
          /* Since 2026-09-16 the last step adds the kit itself (auto-finalise,
             see announceAllSet); this button is the FALLBACK for a kit that
             went all-set silently (page-load fill, a sold-out slot collapsing
             the last choice, a migration) or whose finalise failed. */
          (unfilled === 0 && mixedBasket && !(finalising && finalising[tier])
            ? (function () {
                var loc = math && math.local;
                var priceStr = math
                  ? (loc ? formatLocal(loc.kitPrice, loc.currency) : fmtMoney(math.kitPrice))
                  : '';
                var saveStr = '';
                if (math && (loc ? loc.savings > 0 : math.retail > math.kitPrice)) {
                  saveStr = loc ? formatLocal(loc.savings, loc.currency) : fmtMoney(math.savings);
                }
                var priceLine = priceStr
                  ? '<span class="hgn-side-cart__kit-finalise-price">' + escapeHtml(priceStr) +
                      (saveStr ? ' · save ' + escapeHtml(saveStr) : '') +
                    '</span>'
                  : '';
                return '<button type="button" class="hgn-side-cart__kit-finalise" data-hgn-kit-finalise>' +
                  '<span class="hgn-side-cart__kit-finalise-label">' + ((window.HGN_COPY || {}).kit_add_basket || 'Add my kit to basket') + '</span>' +
                  priceLine +
                '</button>';
              })()
            : '') +
        '</div>';
      }

      /* Browse-more — single anchor that links to the canonical
         tier collection (sourced from `HGN_CANONICAL_COLLECTIONS`,
         falling back to TIER_BROWSE_FALLBACK). CTL was retired
         from this surface — better discovery surfaces (kit-build-
         toggle, hgn-starter-kit-selector Mode B) own that flow now. */
      var footHtml =
        '<div class="hgn-side-cart__kit-foot">' +
          '<div class="hgn-side-cart__kit-foot-row">' +
            '<a class="hgn-side-cart__kit-suggest-toggle hgn-side-cart__kit-suggest-toggle--quiet" href="' + escapeHtml(browseUrlFor(tier)) + '">' +
              '<span>Browse more designs</span>' +
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</a>' +
            (picks > 0 ? '<button type="button" class="hgn-side-cart__kit-recover" data-hgn-kit-recover>Stop Kit, Move Items to Cart</button>' : '') +
          '</div>' +
        '</div>';

      /* Thumbnail preview — closed-state only (CSS hides when head
         is expanded). Renders one tile per pick, then dashed empty
         placeholders up to the kit minimum so the remaining capacity
         is visually obvious. */
      var thumbsHtml = '';
      if (picks > 0) {
        (kit.items || []).forEach(function (it) {
          if (it.image) {
            thumbsHtml += '<span class="hgn-side-cart__kit-thumb"><img src="' + escapeHtml(it.image) + '" alt="" loading="lazy"></span>';
          } else {
            thumbsHtml += '<span class="hgn-side-cart__kit-thumb"></span>';
          }
        });
        var remaining = Math.max(0, minimum - picks);
        for (var i = 0; i < remaining; i++) {
          thumbsHtml += '<span class="hgn-side-cart__kit-thumb hgn-side-cart__kit-thumb--empty" aria-hidden="true">+</span>';
        }
      }
      var thumbsBlock = thumbsHtml
        ? '<div class="hgn-side-cart__kit-thumbs" data-hgn-kit-thumbs>' + thumbsHtml + '</div>'
        : '';

      /* Pricing-disclosure block (#46) — surfaces "what you get for
         this kit price" once the shopper has 1+ picks. Lives between
         the progress bar and the picks list so it's the first thing
         the eye lands on after seeing how many picks they've made. */
      var pricingHtml = buildPricingBlockHtml(tier, kit, math, ready);

      /* Live collage (2026-09-15) — the kit's own picture, straight
         after the progress line and above the pricing block + picks
         list. kitCollageLiveOptions shapes THIS kit (the picks in
         order, the tier's two required accessory slots — the
         shopper's pick, else the market's first option, else hidden
         when the slot is confirmed sold out; optional uplifts never
         appear), 0 picks = the shell picture. The renderer is
         load-once from hgn-announcement; when it is absent this is
         an empty string and the section renders exactly as before.
         kitCollageMarkup is a string, so it rides this same rebuild —
         render() hydrates it after innerHTML. */
      var collageHtml = '';
      try {
        var HC = window.HGN || {};
        if (typeof HC.kitCollageMarkup === 'function' && typeof HC.kitCollageLiveOptions === 'function') {
          collageHtml = '<div class="hgn-side-cart__kit-collage" data-hgn-kit-collage="' + escapeHtml(tier) + '">' +
            HC.kitCollageMarkup(HC.kitCollageLiveOptions(tier, { kit: kit, variant: 'drawer', skin: '' })) +
          '</div>';
        }
      } catch (e) { collageHtml = ''; }

      return '<section class="' + classes.join(' ') + '" data-tier="' + escapeHtml(tier) + '" aria-label="Your ' + escapeHtml(label) + ' in progress">' +
        '<button type="button" class="hgn-side-cart__kit-head" data-hgn-kit-head aria-expanded="' + (desiredOpen ? 'true' : 'false') + '">' +
          '<span class="hgn-side-cart__kit-eyebrow">' + escapeHtml(stepsForCopy ? stepsForCopy.eyebrow : 'Building') + '</span>' +
          '<span class="hgn-side-cart__kit-count">' + picks + '/' + minimum + '</span>' +
          '<svg class="hgn-side-cart__kit-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
            '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<span class="hgn-side-cart__kit-title">' + escapeHtml(label) + '</span>' +
        '</button>' +
        thumbsBlock +
        '<div class="hgn-side-cart__kit-body">' +
          '<div class="hgn-side-cart__kit-progress">' +
            '<span class="hgn-side-cart__kit-progress-line">' + progressLine + '</span>' +
            '<span class="hgn-side-cart__kit-progress-track">' +
              '<span class="hgn-side-cart__kit-progress-fill" style="width:' + pct + '%"></span>' +
            '</span>' +
          '</div>' +
          (collageHtml ? '<div class="hgn-side-cart__kit-summary" data-hgn-kit-summary>' + collageHtml + pricingHtml + '</div>' : pricingHtml) +
          '<div class="hgn-side-cart__kit-picks">' + picksHtml + '</div>' +
          accHtml +
          footHtml +
        '</div>' +
      '</section>';
    }

    /* ─────── All-set announce (2026-08-08) ───────
       When a tier TRANSITIONS to all-set during this page view, open
       the side cart at the build section so the ready kit + its CTA
       are actually seen. Without this, a kit whose required slots are
       all auto-picked singletons (e.g. Classic with the gift bag
       sold out) goes all-set silently on a collection page — the
       beacon funnel showed ~1/3 of ready kits stranding there after
       auto-finalise was retired. Transition-only: the first render
       seeds silently, so landing on a page with an already-complete
       kit never auto-opens the drawer (the kit-bar + foot CTA cover
       that case) and a shopper already IN the drawer isn't scrolled
       away from what they're looking at. */
    /* ─────── Auto-finalise on the last step (Matt, 2026-09-16) ───────
       "put the kit into their subtotal just as soon as they've selected
       their bag". When a tier TRANSITIONS to all-set because of something
       the shopper just did — a design added, an accessory picked, or the
       singleton auto-pick that follows a design add — the kit goes into
       the basket right away: autoFinalise (stock checks → bulk add → kit
       memory cleared → drawer). The 2026-08-05 retirement was about SILENT
       completions (a sold-out gift bag collapsing the last step on a
       collection page), and those still stop at the review state with the
       fallback button. Eligible only when ALL of:
         · a trusted gesture within 2.5 s (pointer / key / touch) — synthetic
           clicks and page-load fills such as ?hgn_kit_complete never count;
         · the change was an `add` / `accessory-set` (never write, switch,
           focus, edit, clear);
         · not within 8 s of the switch turning ON (migrateCartToKits adds
           through addItem too) and no programmatic fill in flight
           (HGN.kitFillHold — held by the curated "Swap a design" path);
         · build mode ON (render() never reaches here otherwise).
       autoFinalise is single-flight per tier, so the PDP one-tap's own
       finalise-request cannot double-add. */
    var lastGestureAt = 0;
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (e && e.isTrusted) lastGestureAt = Date.now(); }, { capture: true, passive: true });
    });
    var lastKitAction = '';
    var modeOnAt = 0;
    function autoFinaliseEligible() {
      if (Date.now() - lastGestureAt > 2500) return false;
      if (lastKitAction !== 'add' && lastKitAction !== 'accessory-set') return false;
      if (modeOnAt && Date.now() - modeOnAt < 8000) return false;
      if (window.HGN && window.HGN.kitFillHold > 0) return false;
      return true;
    }
    var prevAllSet = {};
    var allSetSeeded = false;
    function isAllSet(kit, tier) {
      return !!kit && (kit.items || []).length >= tierMin(tier) &&
        requiredUnfilled(tier, kit) === 0;
    }
    function announceAllSet(kp, state) {
      var announce = null;
      KIT_TIERS.forEach(function (tier) {
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(tier)) return;
        var allSet = isAllSet(state.kits[tier], tier);
        if (allSetSeeded && allSet && !prevAllSet[tier]) announce = tier;
        prevAllSet[tier] = allSet;
      });
      allSetSeeded = true;
      if (!announce) return;
      if (autoFinaliseEligible()) { autoFinalise(announce); return; }
      var drawerOpen = document.documentElement.classList.contains('hgn-side-cart-open');
      if (drawerOpen) return;
      try {
        if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.open === 'function') {
          window.HGN.sideCart.open();
          document.dispatchEvent(new CustomEvent('hgn:side-cart:scroll-to-build'));
        }
      } catch (e) {}
    }

    /* Pre-render auto-pick: for any tier that's ready (picks ≥ min)
       and has singleton accessory options unfilled, set them on the
       shopper's behalf. This runs OUTSIDE the HTML build so the
       setAccessory event chain doesn't recurse into render mid-build.
       Returns true if any picks were made (caller can short-circuit
       since the resulting hgn:kit:change event will trigger another
       render anyway). */
    function autoPickSingletons() {
      var kp = getKp();
      if (!kp) return false;
      var state = kp.read();
      var changed = false;
      KIT_TIERS.forEach(function (tier) {
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(tier)) return;
        var kit = state.kits[tier];
        if (!kit) return;
        var picks = (kit.items || []).length;
        if (picks < tierMin(tier)) return;
        var slots = (kp.ACCESSORY_SLOTS && kp.ACCESSORY_SLOTS[tier]) || [];
        /* Only auto-pick singletons for REQUIRED slots — for optional
           singletons like Magic Remover the shopper must explicitly
           opt in (the slot carries an uplift, so silent auto-pick
           would charge them without consent). */
        var requiredSlots = (kp.REQUIRED_ACCESSORY_SLOTS && kp.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
        var accData = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
        slots.forEach(function (slot) {
          if (kit.accessories && kit.accessories[slot]) return;
          if (requiredSlots.indexOf(slot) === -1) return; // optional → no auto-pick
          var options = accData[slot] || [];
          if (options.length === 1) {
            try {
              if (kp.setAccessory(tier, slot, options[0])) changed = true;
            } catch (e) {}
          }
        });
      });
      return changed;
    }

    /* ─────── Render: rebuild list from current state ─────── */
    function render() {
      var kp = getKp();
      if (!kp) { listEl.innerHTML = ''; return; }
      var buildMode = (typeof kp.getKitBuildMode === 'function') ? kp.getKitBuildMode() : 'off';
      if (buildMode !== 'on') { listEl.innerHTML = ''; return; }
      /* Auto-pick singletons first — if any change was made, the
         emitted hgn:kit:change will queue another render. We can
         continue with the (now stale) state since the next render
         will paint the corrected output a tick later. */
      autoPickSingletons();
      var state = kp.read();
      announceAllSet(kp, state);
      /* Focus filter — when the shopper has committed to a tier via
         the focus modal, only render that tier's section. Other
         tiers' picks (e.g. left over from a previous build) are not
         shown in the side cart but persist in localStorage so they
         re-surface if focus changes. `null` focus = "haven't decided"
         → render every started tier (legacy behaviour). */
      var focus = (typeof kp.getFocus === 'function') ? kp.getFocus() : null;
      /* Render every tier with picks > 0 OR an active accessory.
         Order: classic → gels → press-ons (alphabetical-ish but
         consistent so a shopper's eye doesn't dance between renders). */
      var html = '';
      KIT_TIERS.forEach(function (tier) {
        if (focus && tier !== focus) return;
        /* Per-market: never render a disabled tier — even if cross-
           market localStorage has picks lingering for it. */
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(tier)) return;
        var kit = state.kits[tier];
        if (!kit) return;
        var hasItems = kit.items && kit.items.length > 0;
        var hasAcc = kit.accessories && Object.keys(kit.accessories).some(function (k) {
          return kit.accessories[k] && kit.accessories[k].id;
        });
        if (!hasItems && !hasAcc) return;
        html += buildSectionHtml(tier, kit);
      });
      listEl.innerHTML = html;
      /* Live collage (2026-09-15): the markup above is a string — wire
         its image fallbacks / narrow flag now it is in the DOM.
         Idempotent (the renderer guards per root); never opens the
         drawer, never touches the foot. */
      try {
        if (window.HGN && typeof window.HGN.kitCollageHydrate === 'function') window.HGN.kitCollageHydrate(listEl);
      } catch (e) {}
    }

    /* ─────── Honest worth on the saved-kit card (2026-09-16) ───────
       Once the kit is IN the bag the drawer's own card renders the same
       à-la-carte total the panel above shows — but inside an `<s>`
       (`assets/hgn-side-cart.js` renderBundleCard; that file is not part
       of this working copy and the main snippet has no room left). So
       this controller, which owns the kit's copy everywhere else in the
       drawer, corrects the card as it appears:

         <s class="…bundle-price-rrp">£63.93</s>  £39.99
         →  £39.99  £63.93 if bought separately

       The `<s>` ELEMENT is replaced, not just restyled — CSS alone would
       leave a semantic strike behind a visual none — and the figure moves
       behind the price it qualifies, the order the PDP and the nudge card
       use. Compare-before-write: the pass only ever matches an `<s>` that
       is still there, so it converges after one go and the drawer's
       render loops (and the observer below, which sees this pass's own
       writes) cannot thrash it. Never touches a real was-price: line
       prices, the pair offer and gift strikes are different elements. */
    function relabelBundleWorth() {
      var struck;
      try { struck = document.querySelectorAll('s.hgn-side-cart__bundle-price-rrp'); } catch (e) { return 0; }
      var n = 0;
      for (var i = 0; i < struck.length; i++) {
        var old = struck[i];
        var price = old.parentNode;
        var fig = String(old.textContent || '').trim();
        /* No figure to qualify → leave the DOM exactly as it is. */
        if (!price || !fig || fig.indexOf(WORTH_SUFFIX) !== -1) continue;
        var span = document.createElement('span');
        span.setAttribute('class', 'hgn-side-cart__bundle-price-rrp hgn-side-cart__bundle-price-worth');
        span.setAttribute('data-hgn-kit-worth', '');
        span.textContent = fig + WORTH_SUFFIX;
        var paid = price.querySelector('.hgn-side-cart__bundle-price-paid');
        if (paid) {
          if (paid.nextSibling) price.insertBefore(span, paid.nextSibling);
          else price.appendChild(span);
        } else {
          price.insertBefore(span, old);
        }
        old.remove();
        n++;
      }
      return n;
    }
    /* The side cart repaints its lines then broadcasts, so a listener
       sees the finished markup; `hgn:cart:open` covers a repaint that
       rides an already-cached cart. The observer is the belt for any
       repaint that announces nothing — skipped where it doesn't exist
       (the harness DOM), where the events alone still carry the pass. */
    relabelBundleWorth();
    document.addEventListener('hgn:cart:change', relabelBundleWorth);
    document.addEventListener('hgn:cart:open', relabelBundleWorth);
    try {
      var sideCartItemsEl = document.querySelector('[data-hgn-side-cart-items]');
      if (sideCartItemsEl && typeof window.MutationObserver === 'function') {
        new window.MutationObserver(function () { relabelBundleWorth(); })
          .observe(sideCartItemsEl, { childList: true, subtree: true });
      }
    } catch (e) {}
    /* Exported so audit-harness/kit-live-collage.test.js can drive the
       REAL pass rather than a copy of it. */
    try { window.HGN = window.HGN || {}; window.HGN.kitBundleWorthRelabel = relabelBundleWorth; } catch (e) {}

    /* ─────── Delegated click handler — single binding, scoped per tier ─────── */
    listEl.addEventListener('click', function (e) {
      var section = e.target.closest('.hgn-side-cart__kit[data-tier]');
      if (!section) return;
      var tier = section.getAttribute('data-tier');
      if (!tier) return;
      var kp = getKp();
      if (!kp) return;

      /* Concertina head */
      var head = e.target.closest('[data-hgn-kit-head]');
      if (head) {
        var nowOpen = head.getAttribute('aria-expanded') !== 'true';
        manualOpen[tier] = nowOpen ? 'open' : 'closed';
        render();
        return;
      }

      /* Pick remove */
      var rem = e.target.closest('[data-hgn-kit-pick-remove]');
      if (rem) {
        var id = rem.getAttribute('data-id');
        if (id) kp.removeItem(tier, id);
        return;
      }

      /* Add-kit-to-basket — the review stage's commit. autoFinalise is
         single-flight per tier, so double-taps no-op; the button itself
         is left enabled (success clears the section via re-render;
         failure surfaces the retry modal). */
      var fin = e.target.closest('[data-hgn-kit-finalise]');
      if (fin) {
        fin.textContent = 'Adding your kit…';
        autoFinalise(tier);
        return;
      }

      /* Accessory toggle */
      var accToggle = e.target.closest('[data-hgn-kit-acc-toggle]');
      if (accToggle && !accToggle.disabled) {
        var slot = accToggle.getAttribute('data-slot');
        var data = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
        var optionsForSlot = data[slot] || [];
        /* Optional singleton (e.g. Magic Remover) — clicking the row
           action toggles the pick directly: opt-in if not picked,
           remove if picked. No option grid to pop because there's
           only one choice. */
        var requiredSlots = (kp.REQUIRED_ACCESSORY_SLOTS && kp.REQUIRED_ACCESSORY_SLOTS[tier]) || [];
        var isOptionalSingleton = optionsForSlot.length === 1 && requiredSlots.indexOf(slot) === -1;
        if (isOptionalSingleton) {
          var existing = (kp.getAccessory ? kp.getAccessory(tier, slot) : null);
          if (existing && existing.id) {
            if (typeof kp.clearAccessory === 'function') kp.clearAccessory(tier, slot);
          } else {
            kp.setAccessory(tier, slot, optionsForSlot[0]);
          }
          return;
        }
        var key = tier + ':' + slot;
        openSlots[key] = !openSlots[key];
        render();
        return;
      }

      /* Accessory option pick */
      var accOpt = e.target.closest('[data-hgn-kit-acc-option]');
      if (accOpt) {
        var optSlot = accOpt.getAttribute('data-slot');
        var optId = accOpt.getAttribute('data-id');
        var data = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
        var options = data[optSlot] || [];
        var chosen = options.find(function (o) { return String(o.id) === String(optId); });
        if (!chosen) return;
        openSlots[tier + ':' + optSlot] = false;
        kp.setAccessory(tier, optSlot, chosen);
        return;
      }

      /* Browse-more is a plain anchor now (CTL retired from the
         side-cart kit-build flow). Letting the click fall through
         to the browser's default navigation keeps it straight-
         forward — no concertina toggle to handle. */

      /* Recover-to-cart (this tier specifically — not the global flip).
         Mirrors the legacy behaviour but applies just to this tier:
         move picks to cart, clear the kit. */
      var recover = e.target.closest('[data-hgn-kit-recover]');
      if (recover) {
        recover.disabled = true;
        recover.textContent = 'Moving\u2026';
        var picks = (kp.read().kits[tier] || { items: [] }).items;
        if (!picks.length) { recover.disabled = false; recover.textContent = 'Stop Kit, Move Items to Cart'; return; }
        Promise.all(picks.map(function (item) {
          if (item.variantId) return Promise.resolve({ id: parseInt(item.variantId, 10), quantity: 1 });
          if (!item.handle) return Promise.resolve(null);
          return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (!p || !Array.isArray(p.variants) || p.variants.length === 0) return null;
              var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
              return { id: parseInt(v.id, 10), quantity: 1 };
            })
            .catch(function () { return null; });
        })).then(function (resolved) {
          var ok = resolved.filter(function (v) { return v && v.id; });
          if (!ok.length) throw new Error('no-resolvable-variants');
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ok })
          });
        }).then(function (res) {
          if (!res.ok) throw new Error('cart-add-failed');
          kp.clearKit(tier);
          /* Strong intent signal — the shopper has explicitly moved
             their kit picks back to cart at retail. Switch build
             mode OFF and clear focus so the next ATC click is a
             plain cart-add, not a kit-add. They can flip the toggle
             back on if they change their minds; the focus modal
             will re-prompt with smart ranking. skipMigration
             because the picks are already gone — no kit→cart move
             needed. */
          if (typeof kp.setKitBuildMode === 'function') {
            kp.setKitBuildMode('off', { skipMigration: true, source: 'move-picks-to-cart' });
          }
          if (typeof kp.setFocus === 'function') kp.setFocus(null);
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (e) {}
        }).catch(function () {
          recover.disabled = false;
          recover.textContent = 'Stop Kit, Move Items to Cart';
        });
        return;
      }
    });

    /* ─────── Subscriptions + auto-finalise ─────── */
    document.addEventListener('hgn:kit:change', function (e) {
      var action = String((e && e.detail && e.detail.action) || '');
      lastKitAction = action;
      /* the switch writes its flag before migrating (kit-progress
         persist('switch')) — start the migration hold here too */
      if (action === 'switch') modeOnAt = Date.now();
      render();
    });
    document.addEventListener('hgn:kit-build-mode:change', function (e) {
      if (e && e.detail && e.detail.to === 'on') modeOnAt = Date.now();
      render();
    });
    /* Focus change re-renders so the kit-list filters to (or releases
       from) the chosen tier without needing a kit mutation to trigger. */
    document.addEventListener('hgn:kit:focus:change', render);
    /* Currency-aware re-render: the pricing block formats every GBP
       amount via window.HGN.formatLive(gbp, key), so when the visitor
       switches currency or live FX rates land, we re-render so the
       kit price / retail / savings reflect the new rate. */
    document.addEventListener('shopify:currency:update', render);
    document.addEventListener('hgn:fx:update', render);
    /* Cart-line changes flip the in-list finalise CTA between its
       mixed-basket (visible) and kit-only (hidden — foot one-tap owns
       it) states, so re-render when the side cart broadcasts a fresh
       cart. Cheap: render() reads local state only, no fetches. */
    document.addEventListener('hgn:cart:change', render);

    /* Review-before-basket (Matt, 2026-08-05): the AUTOMATIC finalise on
       the last accessory pick is RETIRED. It was designed when the
       gift-bag colour choice was the natural final step — with the bag
       slot degraded (sold out), the kit banged into the cart the moment
       top coat landed, skipping the review moment and every upsell slot.
       The all-set state now renders an explicit "Add my kit to basket"
       button (see the acc block in render()) and finalise only ever runs
       from that tap or its retry modal. This also gives the curated-
       completion email landing its review stage for free. */

    /* ─────── Cross-file finalise contract (2026-08-08) ───────
       The side cart's foot button becomes the kit CTA when the cart
       has no lines (Matt: a separate finalise step is unnecessary for
       shoppers who just want the kit). Two pieces:
       - window.HGN.kitFinaliseState(tier) → { picks, minimum, ready,
         unfilled } — lets hgn-side-cart.liquid ask "is this kit
         all-set?" using THIS file's definition (requiredUnfilled),
         so the two files can't disagree about readiness.
       - hgn:kit:finalise-request {detail:{tier}} — runs autoFinalise
         for an all-set tier. Guarded by the same checks the in-list
         CTA gets for free from its render condition. */
    try {
      window.HGN = window.HGN || {};
      window.HGN.kitFinaliseState = function (tier) {
        var kp = getKp();
        if (!kp) return null;
        var kit = kp.read().kits[tier];
        if (!kit) return null;
        var picks = (kit.items || []).length;
        return {
          picks:    picks,
          minimum:  tierMin(tier),
          ready:    picks >= tierMin(tier),
          unfilled: requiredUnfilled(tier, kit)
        };
      };
    } catch (e) {}
    document.addEventListener('hgn:kit:finalise-request', function (e) {
      var tier = e && e.detail && e.detail.tier;
      if (!tier) return;
      var kp = getKp();
      if (!kp) return;
      var kit = kp.read().kits[tier];
      if (!isAllSet(kit, tier)) return;
      autoFinalise(tier);
    });

    var KIT_DISPLAY_LABEL = {
      classic:     'Classic Wraps Starter Kit',
      gels:        'Gel Wraps Starter Kit',
      'press-ons': 'Press-On Starter Kit'
    };

    /* ─────── Out-of-stock guard ───────
       Pre-flight stock check for picks before any kit→cart transfer.
       Without this, /cart/add.js fails with a 422 (Shopify rejects the
       whole bulk add if any line is unavailable) and the kit silently
       stays put — the shopper sees their accessories picked but no
       cart update, with no explanation. Cause is usually that a pick
       was bought by another shopper between the time the kit hit
       minimum and the time the shopper finished picking accessories.

       Strategy: for every pick with a `handle`, fetch
       /products/<handle>.js and read `product.available`. Picks
       without a handle (rare — only legacy/pre-resolved variantIds)
       pass through; if those turn out to be OOS, the cart-add 422
       backstop below catches them with a generic modal.

       Returns Promise<{ available: [...], oos: [...] }> where each
       entry is the ORIGINAL kit item (id/title/image/handle/price
       preserved) so the modal can render thumbnails + titles. */
    function verifyPicksInStock(picks) {
      if (!Array.isArray(picks) || picks.length === 0) {
        return Promise.resolve({ available: [], oos: [] });
      }
      return Promise.all(picks.map(function (item) {
        if (!item) return Promise.resolve({ item: null, available: false });
        if (!item.handle) {
          /* No handle to check — assume available; if the cart-add
             rejects, the 422 backstop will surface the failure. */
          return Promise.resolve({ item: item, available: true });
        }
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js', {
          credentials: 'same-origin'
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (product) {
            if (!product) return { item: item, available: true };
            /* Variant-level check when the pick carries a variantId —
               product.available is true if ANY variant is in stock,
               which lets a sold-out picked variant through to a 422
               (audit B5.6). Fall back to product-level otherwise. */
            if (item.variantId && Array.isArray(product.variants)) {
              var v = product.variants.find(function (x) {
                return String(x.id) === String(item.variantId);
              });
              if (v) return { item: item, available: v.available !== false };
            }
            return { item: item, available: product.available !== false };
          })
          .catch(function () { return { item: item, available: true }; });
      })).then(function (results) {
        var available = [];
        var oos = [];
        results.forEach(function (r) {
          if (!r || !r.item) return;
          if (r.available) available.push(r.item);
          else oos.push(r.item);
        });
        return { available: available, oos: oos };
      });
    }

    /* ─────── Accessory stock guard (2026-08-02) ───────
       Accessories used to be exempt from the pre-flight, on the stated
       assumption that merchant-curated slots stay in stock. The Mani
       Make-up Bag run-down disproved it. One dead accessory variant
       422s the ENTIRE bulk cart-add, which makes every kit on the site
       unfinishable — a far worse failure than any single design
       selling out, and one with no visible cause for the shopper.

       Two outcomes, deliberately different:
         gift slots      → drop it and carry on finalising, silently.
           The kit is still a complete product without a freebie, and
           interrupting someone at the moment of cart-add to announce
           a missing gift would cost more than it saves.
         everything else → treat exactly like an OOS design pick:
           clear it and surface the modal so the shopper re-picks.

       Dead picks are cleared from kit memory in both cases, so the
       kit-build UI is already correct whichever branch the caller
       takes. Resolves { accessories, dropped, blocking }. */
    function verifyAccessoriesInStock(tier, accObj) {
      var kp = getKp();
      var giftSlots = (kp && kp.GIFT_SLOTS) || ['giftBag'];
      var entries = Object.keys(accObj || {})
        .map(function (slot) { return { slot: slot, item: accObj[slot] }; })
        .filter(function (e) { return e.item && (e.item.variantId || e.item.id); });
      if (!entries.length) {
        return Promise.resolve({ accessories: [], dropped: [], blocking: [] });
      }
      return Promise.all(entries.map(function (e) {
        return verifyPicksInStock([e.item]).then(function (v) {
          return { slot: e.slot, item: e.item, available: v.oos.length === 0 };
        });
      })).then(function (results) {
        var accessories = [], dropped = [], blocking = [];
        results.forEach(function (r) {
          if (r.available) { accessories.push(r.item); return; }
          if (giftSlots.indexOf(r.slot) !== -1) dropped.push(r); else blocking.push(r);
        });
        if (kp && typeof kp.clearAccessory === 'function') {
          dropped.concat(blocking).forEach(function (r) {
            try { kp.clearAccessory(tier, r.slot); } catch (err) {}
          });
        }
        return { accessories: accessories, dropped: dropped, blocking: blocking };
      });
    }

    /* OOS modal — reuses the .hgn-finish-kit-modal__* CSS chrome for
       visual consistency with the other side-cart modals. Lists the
       picks that just sold out, drops them from kit memory so the
       kit-build section re-renders below minimum (re-enabling
       picking), and offers two paths back to discovery:

         - Browse {label} designs → canonical tier collection
         - Pick replacements here → dismiss + leave shopper in cart

       Resolves on dismiss; never blocks. The caller has already
       removed the OOS picks from kit memory before showing the modal
       (so the kit-build UI is correct as soon as the modal appears). */
    function showOOSModal(tier, oosItems) {
      return new Promise(function (resolve) {
        var existing = document.querySelector('[data-hgn-kit-oos-modal]');
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

        var label = kitLabelFor(tier);
        var noun = tierNoun(tier, 2);
        var count = oosItems.length;
        var lead = count === 1
          ? '1 of your ' + escapeHtml(label) + ' picks has just sold out:'
          : count + ' of your ' + escapeHtml(label) + ' picks have just sold out:';

        var picksHtml = oosItems.map(function (it) {
          var thumb = it && it.image
            ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">'
            : '';
          var title = (it && it.title) ? it.title : 'This design';
          return '<li class="hgn-kit-oos-modal__pick">' +
            '<span class="hgn-kit-oos-modal__pick-thumb">' + thumb + '</span>' +
            '<span class="hgn-kit-oos-modal__pick-title">' + escapeHtml(title) + '</span>' +
          '</li>';
        }).join('');

        var browseUrl = browseUrlFor(tier);
        var browseLabel = 'Browse more ' + escapeHtml(noun);

        var modal = document.createElement('div');
        modal.className = 'hgn-finish-kit-modal hgn-kit-oos-modal';
        modal.setAttribute('data-hgn-kit-oos-modal', '');
        modal.innerHTML =
          '<div class="hgn-finish-kit-modal__scrim" data-hgn-kit-oos-cancel></div>' +
          '<div class="hgn-finish-kit-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hgn-kit-oos-title">' +
            '<header class="hgn-finish-kit-modal__head">' +
              '<p class="hgn-finish-kit-modal__eyebrow">Just sold out</p>' +
              '<h2 class="hgn-finish-kit-modal__title" id="hgn-kit-oos-title">' +
                'Pick ' + (count === 1 ? 'a replacement' : 'replacements') + ' for your ' + escapeHtml(label) +
              '</h2>' +
              '<p class="hgn-finish-kit-modal__copy">' + lead + '</p>' +
              '<ul class="hgn-kit-oos-modal__list">' + picksHtml + '</ul>' +
              '<p class="hgn-finish-kit-modal__copy hgn-kit-oos-modal__hint">' +
                'We’ve removed ' + (count === 1 ? 'it' : 'them') + ' from your kit so you can pick ' +
                (count === 1 ? 'a replacement' : 'replacements') + ' and finish off your kit.' +
              '</p>' +
            '</header>' +
            '<div class="hgn-finish-kit-modal__foot">' +
              '<button type="button" class="hgn-finish-kit-modal__cancel" data-hgn-kit-oos-stay>Pick here</button>' +
              '<a class="hgn-finish-kit-modal__confirm" href="' + escapeHtml(browseUrl) + '" data-hgn-kit-oos-browse>' +
                browseLabel +
              '</a>' +
            '</div>' +
          '</div>';

        document.body.appendChild(modal);

        function done(decision) {
          if (modal.parentNode) modal.parentNode.removeChild(modal);
          document.removeEventListener('keydown', onKey);
          resolve(decision || 'stay');
        }
        function onKey(e) { if (e.key === 'Escape') done('stay'); }

        modal.addEventListener('click', function (e) {
          if (e.target.closest('[data-hgn-kit-oos-cancel]')) { done('stay'); return; }
          if (e.target.closest('[data-hgn-kit-oos-stay]')) { done('stay'); return; }
          /* Browse link is a real anchor — let the browser navigate.
             We still resolve so any post-modal cleanup can run if the
             page transition is interrupted. */
          if (e.target.closest('[data-hgn-kit-oos-browse]')) { resolve('browse'); }
        });
        document.addEventListener('keydown', onKey);
      });
    }

    /* Drops the OOS picks from kitProgress so the kit-build UI
       updates instantly (kit slides back below minimum, "Ready · pick
       accessories" disappears). Then shows the modal. Caller awaits
       the returned promise — no further cart-add happens. */
    function handleOOS(tier, oosItems) {
      var kp = getKp();
      if (kp && typeof kp.removeItem === 'function') {
        oosItems.forEach(function (it) {
          if (it && it.id != null) {
            try { kp.removeItem(tier, it.id); } catch (e) {}
          }
        });
      }
      return showOOSModal(tier, oosItems);
    }

    var finalising = {};
    function autoFinalise(tier) {
      if (finalising[tier]) return;
      finalising[tier] = true;
      var kp = getKp();
      if (!kp) { finalising[tier] = false; return; }
      var state = kp.read();
      var kit = state.kits[tier];
      if (!kit) { finalising[tier] = false; return; }

      var prices = window.HGN_KIT_BUNDLE_PRICES || {};
      var basePrice = (typeof prices[tier] === 'number') ? prices[tier] : 0;
      var accObj = kit.accessories || {};
      var totalUplift = 0;
      Object.keys(accObj).forEach(function (slot) {
        var v = accObj[slot];
        if (v && typeof v.uplift === 'number') totalUplift += v.uplift;
      });
      /* ───── GBP-canonical bundle pricing ─────
         `_bundle_price_gbp_cents` and `_bundle_retail_gbp_cents` are
         both in GBP pence, sourced from HGN_KIT_BUNDLE_PRICES and
         HGN_KIT_RETAILS (the same merchant-configured GBP values the
         kit-build pricing block above uses). The side cart reads them
         verbatim on the next /cart.js fetch and converts to active
         currency at display time via formatLive — so a USD shopper
         sees "$50" while the underlying maths stays GBP throughout
         (and the worker mints a £-denominated discount that Shopify
         converts to presentment currency at checkout).
         LOCAL-sticker markets (M4): the shopper was promised a FIXED
         local price — (sticker + uplifts converted to local). The
         props stay GBP pence (mint + cart-page contracts unchanged),
         so invert that local target to GBP at the same live rate the
         side cart's presentmentToGbpCents uses (identical fallback
         table). No sticker → the GBP settings value IS the promise. */
      var bundlePriceGbpCents;
      var bundlePriceLocalCents = null;
      var bundlePriceLocalIso = '';
      var finaliseSticker = localSticker(tier);
      if (finaliseSticker) {
        var finaliseRate = localFxRate(finaliseSticker.currency);
        bundlePriceLocalCents = Math.round((finaliseSticker.amount + totalUplift * finaliseRate) * 100);
        bundlePriceLocalIso = String(finaliseSticker.currency).toUpperCase();
        bundlePriceGbpCents = Math.round(bundlePriceLocalCents / finaliseRate);
      } else {
        bundlePriceGbpCents = Math.round((basePrice + totalUplift) * 100);
      }
      var kitMath = computeKitMath(tier, kit);
      /* Retail snapshot (INFORMATIONAL ONLY — nothing computes from
         it): product-basis local retail inverted to GBP when the v2
         basis is in play, so the property stays consistent with the
         displayed savings; legacy worth table otherwise. */
      var bundleRetailGbpCents;
      if (kitMath.local && kitMath.local.basis === 'product') {
        bundleRetailGbpCents = Math.round((kitMath.local.retail / localFxRate(kitMath.local.currency)) * 100);
      } else {
        bundleRetailGbpCents = Math.round((kitMath.retail || 0) * 100);
      }
      var bundleId = 'box-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
      var displayLabel = KIT_DISPLAY_LABEL[tier] || 'Starter Kit';
      /* Property notes (2026-07-10):
         - `_bundle_price_cents` — same GBP-pence target, under the
           key the redesigned cart PAGE reads (hgn-cart-page.liquid
           derives savings as Σ actual line prices − this target).
           Without it, kit-build bundles showed ZERO savings on the
           cart page (only send-to-starter-kit bundles carried it).
         - `_bundle_retail_gbp_cents` — the HGN_KIT_RETAILS table
           figure. INFORMATIONAL ONLY since the actual-price savings
           rewrite (the table drifted from real line prices and
           under-minted the checkout discount); the side cart now
           derives savings from actual cart line prices vs the
           target. Kept for debugging/analytics. */
      var bundleProps = {
        '_bundle_type':             tier + '-starter-kit',
        '_bundle_id':               bundleId,
        '_bundle_price_cents':      String(bundlePriceGbpCents),
        '_bundle_price_gbp_cents':  String(bundlePriceGbpCents),
        '_bundle_retail_gbp_cents': String(bundleRetailGbpCents),
        'Bundle':                   displayLabel,
        '_box_id':                  bundleId
      };
      /* Sticker markets: ALSO stamp the promise in the currency it was
         made in. The GBP props above are an FX inversion done at THIS
         moment; the side cart converts them back at render time, so any
         rate movement between the two (a cart lives 14 days) silently
         moves the kit price off its fixed sticker. With these two the
         drawer can read the promise back verbatim and the round trip
         disappears — the GBP props stay untouched for the mint payload
         and the cart-page contract. GBP markets emit neither, so their
         cart lines are byte-for-byte what they were. */
      if (bundlePriceLocalCents != null && bundlePriceLocalIso) {
        bundleProps['_bundle_price_local_cents'] = String(bundlePriceLocalCents);
        bundleProps['_bundle_price_currency']    = bundlePriceLocalIso;
      }

      /* Curated edit (2026-09-16): when the kit is still "their Halloween
         Edit" at this moment (kitProgress owns that rule), stamp the edit on
         every bundle line — hidden props, so checkout shows nothing new —
         and the saved-kit card names and pictures the kit as that edit. */
      try {
        var editLabel = (typeof kp.kitEditLabel === 'function') ? kp.kitEditLabel(tier) : '';
        var edit = (editLabel && typeof kp.getEdit === 'function') ? kp.getEdit(tier) : null;
        if (edit && edit.title) {
          bundleProps['_hgn_edit_title'] = String(edit.title);
          if (edit.slug) bundleProps['_hgn_edit_slug'] = String(edit.slug);
          if (edit.skin) bundleProps['_hgn_edit_skin'] = String(edit.skin);
        }
      } catch (e) {}

      /* The accessory line-up is no longer flattened here — it comes
         back from verifyAccessoriesInStock below, already filtered to
         what's genuinely purchasable. */
      var picks = kit.items || [];

      function resolve(item) {
        if (!item) return Promise.resolve(null);
        if (item.variantId) return Promise.resolve({ id: parseInt(item.variantId, 10), quantity: 1, properties: bundleProps });
        if (!item.handle) return Promise.resolve(null);
        return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !Array.isArray(p.variants) || p.variants.length === 0) return null;
            var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
            return { id: parseInt(v.id, 10), quantity: 1, properties: bundleProps };
          })
          .catch(function () { return null; });
      }

      /* Pre-flight stock check. Designs first: if a pick is OOS, drop it
         from kit memory, show the modal, and bail without touching the
         cart — the shopper sees the kit slide below minimum and can pick
         replacements in place.

         Then accessories (2026-08-02 — they used to be exempt; see
         verifyAccessoriesInStock for why that was wrong). A sold-out
         gift is dropped and the finalise continues; anything else is a
         blocker and reuses the same modal. Note the gift drop can't
         disturb the price already computed above: gift slots carry a
         zero uplift by definition, so `totalUplift` is unaffected. */
      verifyPicksInStock(picks)
        .then(function (verdict) {
          if (verdict.oos.length) {
            return handleOOS(tier, verdict.oos).then(function () { return null; });
          }
          return verifyAccessoriesInStock(tier, accObj).then(function (accVerdict) {
            if (accVerdict.blocking.length) {
              /* Already cleared from kit memory by the verifier, so go
                 straight to the modal rather than through handleOOS
                 (which removes DESIGN picks by id). */
              return showOOSModal(tier, accVerdict.blocking.map(function (b) { return b.item; }))
                .then(function () { return null; });
            }
            return Promise.all([].concat(picks, accVerdict.accessories).map(resolve));
          });
        })
        .then(function (resolved) {
          if (resolved == null) return null; /* OOS path — finalise aborted */
          var ok = resolved.filter(function (v) { return v && v.id; });
          if (ok.length !== resolved.length) throw new Error('variant-resolution-failed');
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ok })
          }).then(function (res) {
            if (!res.ok) throw new Error('cart-add-failed');
            return res.json();
          }).then(function () {
            /* Defensive accessory reset BEFORE clearKit. If the user
               immediately starts another kit of this tier, the new kit
               must NOT inherit any accessory the previous one had
               picked. clearKit alone should handle this, but doing
               the slot-by-slot clear first guarantees cleanup even
               if any future code path skips clearKit's reset. */
            try {
              if (typeof kp.clearAccessory === 'function') {
                var slots = (kp.ACCESSORY_SLOTS && kp.ACCESSORY_SLOTS[tier]) || [];
                slots.forEach(function (slot) { kp.clearAccessory(tier, slot); });
              }
            } catch (e) {}
            kp.clearKit(tier);
            /* Always clear focus on finalise. The kit we were focused
               on is now in the cart; leaving focus pinned would keep
               other-tier product cards looking off-focus (plain "Add"
               instead of "Add to Starter Kit") until the shopper
               manually flipped the toggle. Resetting to null lets the
               focus modal re-prompt cleanly on the next ON. */
            try {
              if (typeof kp.setFocus === 'function') kp.setFocus(null);
            } catch (e) {}
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
            } catch (e) {}
            /* Auto-switch-off the kit-build mode unless another tier
               is still in progress. The shopper has just sent a kit
               to cart; if no other kits remain, dropping out of build
               mode returns the site to its normal ATC behaviour. The
               ON state stays if (e.g.) Press-On was sent while Classic
               still has picks. */
            try {
              var s = kp.read();
              var anyOther = ['classic', 'gels', 'press-ons'].some(function (t) {
                return s.kits[t] && s.kits[t].items && s.kits[t].items.length > 0;
              });
              if (!anyOther && typeof kp.setKitBuildMode === 'function' &&
                  kp.getKitBuildMode() === 'on') {
                kp.setKitBuildMode('off', { skipMigration: true, source: 'auto-finalise' });
              }
            } catch (e) {}
            if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.open === 'function') {
              window.HGN.sideCart.open();
            }
          });
        })
        .catch(function () {
          /* The kit stays fully intact on failure (nothing was removed
             from kit memory before the cart-add settles), but silence
             left the shopper stranded: accessories picked, no cart
             update, no explanation (audit B5.6 — the "422 backstop"
             this file's comments promised never existed). Offer a
             retry via the OOS modal chrome. */
          showFinaliseErrorModal(tier);
        })
        .then(function () { finalising[tier] = false; });
    }

    /* Generic finalise-failure modal — reuses the .hgn-finish-kit-modal
       chrome (same classes as the OOS modal above). Try again re-runs
       autoFinalise for the tier; Not now dismisses (kit + picks intact,
       shopper can re-trigger by re-picking an accessory). */
    function showFinaliseErrorModal(tier) {
      var existing = document.querySelector('[data-hgn-kit-finalise-error]');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      var label = kitLabelFor(tier);
      var modal = document.createElement('div');
      modal.className = 'hgn-finish-kit-modal';
      modal.setAttribute('data-hgn-kit-finalise-error', '');
      modal.innerHTML =
        '<div class="hgn-finish-kit-modal__scrim" data-hgn-kit-ferr-dismiss></div>' +
        '<div class="hgn-finish-kit-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hgn-kit-ferr-title">' +
          '<header class="hgn-finish-kit-modal__head">' +
            '<p class="hgn-finish-kit-modal__eyebrow">Nearly there</p>' +
            '<h2 class="hgn-finish-kit-modal__title" id="hgn-kit-ferr-title">We couldn\u2019t add your ' + escapeHtml(label) + ' to the cart</h2>' +
            '<p class="hgn-finish-kit-modal__copy">Something went wrong on the way to your cart \u2014 usually a connection blip. Your picks and accessories are safe.</p>' +
          '</header>' +
          '<div class="hgn-finish-kit-modal__foot">' +
            '<button type="button" class="hgn-finish-kit-modal__cancel" data-hgn-kit-ferr-dismiss>Not now</button>' +
            '<button type="button" class="hgn-finish-kit-modal__confirm" data-hgn-kit-ferr-retry>Try again</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modal);
      function close() {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
        document.removeEventListener('keydown', onKey);
      }
      function onKey(e) { if (e.key === 'Escape') close(); }
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-kit-ferr-retry]')) {
          close();
          autoFinalise(tier);
          return;
        }
        if (e.target.closest('[data-hgn-kit-ferr-dismiss]')) close();
      });
      document.addEventListener('keydown', onKey);
    }

    /* ─────── Blocking-slot focus (audit A2, 2026-08-12) ───────
       "FINISH MY KIT" at 5/5 with the gift bag unpicked did literally
       nothing: the foot fired a bare scroll-to-build, the kit section
       was already at the top of the scroller, so scrollIntoView was a
       no-op and the row that actually blocks the kit sat below the
       fold. A dead primary CTA.

       Given a tier, this opens that tier's concertina, expands the
       blocking slot's option grid (so the bag-colour picker is
       already open — the tap advances the shopper, it doesn't just
       point at work), centres the row in the drawer and pulses it.
       Falls back to the plain scroll if nothing is actually blocking,
       so the tap is never a no-op again. */
    function focusBlockingSlot(tier) {
      var kp = getKp();
      if (!kp) return;
      var state = kp.read();
      var tiers = tier ? [tier] : KIT_TIERS;
      var target = null;
      var slot = null;
      for (var i = 0; i < tiers.length && !slot; i++) {
        var t = tiers[i];
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) continue;
        var kit = state.kits[t];
        if (!kit || (kit.items || []).length < tierMin(t)) continue;
        var missing = missingRequired(t, kit);
        if (!missing.length) continue;
        target = t;
        slot = missing[0];
      }
      if (!slot) { scrollToFirstSection(); return; }
      manualOpen[target] = 'open';
      var accData = (window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[target]) || {};
      /* Singletons have no grid to open (the row action is disabled
         for required ones) — the pulse alone carries the message. */
      if ((accData[slot] || []).length > 1) openSlots[target + ':' + slot] = true;
      render();
      setTimeout(function () {
        var row = listEl.querySelector(
          '.hgn-side-cart__kit[data-tier="' + target + '"] .hgn-side-cart__kit-acc-row[data-slot="' + slot + '"]');
        if (!row) { scrollToFirstSection(); return; }
        try { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        row.classList.remove('is-nudge');
        /* Force a reflow so a second tap restarts the animation
           instead of landing on an already-finished one. */
        void row.offsetWidth;
        row.classList.add('is-nudge');
        setTimeout(function () { row.classList.remove('is-nudge'); }, 2000);
      }, 240);
    }

    function scrollToFirstSection() {
      setTimeout(function () {
        var first = listEl.querySelector('.hgn-side-cart__kit');
        var target = first || listEl;
        if (!target) return;
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {}
      }, 220);
    }

    /* Scroll-to-build event handler — scrolls the first rendered
       section into view (or the wrapper if empty). With
       `detail.focus === 'required-slot'` it instead jumps to the slot
       that's blocking the kit (see focusBlockingSlot). */
    document.addEventListener('hgn:side-cart:scroll-to-build', function (e) {
      var detail = (e && e.detail) || {};
      if (detail.focus === 'required-slot') { focusBlockingSlot(detail.tier); return; }
      scrollToFirstSection();
    });

    /* Kit just hit its minimum — open the side cart and scroll to
       the tier's section so the shopper sees the "Ready · pick
       accessories" state and the inline accessory grid. Force-opens
       the section's concertina even if the shopper had collapsed it. */
    document.addEventListener('hgn:kit:reached-minimum', function (e) {
      var tier = e && e.detail && e.detail.tier;
      if (!tier) return;
      manualOpen[tier] = 'open';
      render();
      if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.open === 'function') {
        window.HGN.sideCart.open();
      }
      setTimeout(function () {
        var sect = listEl.querySelector('.hgn-side-cart__kit[data-tier="' + tier + '"]');
        var target = sect || listEl.querySelector('.hgn-side-cart__kit') || listEl;
        if (!target) return;
        try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) {}
      }, 320);
    });

    render();
  });
})();
